// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_entitlement.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { App } from "./app";
import { AppGroup } from "./app_group";
import { GrantReason } from "./app_entitlement_user_binding_reasons";
import { AppUser } from "./app_user";
import { UserRef } from "../../user/v1/user";
import { AppUserRef } from "./app_user";
import { AppUserExpandMask } from "./app_user";
import { AppUserView } from "./app_user";
import { ActorObjectPermissions } from "../../iam/v1/authorization";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { ProvisionPolicy } from "../../policy/v1/policy";
import { Duration } from "../../../../google/protobuf/duration";
import { Empty } from "../../../../google/protobuf/empty";
import { AppEntitlementUserBinding } from "./app_entitlement_user_binding";
import { AppEntitlementUserBindingRef } from "./app_refs";
import { User } from "../../user/v1/user";
import { PolicyRef } from "../../policy/v1/policy";
import { Facets } from "../../search/v1/facet";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { Any } from "../../../../google/protobuf/any";
import { AppEntitlementRef } from "./app_refs";
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementUserBindingDestinationsRequest
 */
export interface SearchAppEntitlementUserBindingDestinationsRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string app_user_id = 3;
     */
    appUserId: string;
    /**
     * @generated from protobuf field: int32 page_size = 4;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 5;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementUserBindingDestinationsResponse
 */
export interface SearchAppEntitlementUserBindingDestinationsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef list = 1;
     */
    list: AppEntitlementRef[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementCorrelation
 */
export interface AppEntitlementCorrelation {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementRef app_entitlement = 1;
     */
    appEntitlement?: AppEntitlementRef;
    /**
     * @generated from protobuf field: optional double distance = 2;
     */
    distance?: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementCorrelationForAccessProfileRequest
 */
export interface SearchAppEntitlementCorrelationForAccessProfileRequest {
    /**
     * @generated from protobuf field: string access_profile_id = 1;
     */
    accessProfileId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 4;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string app_ids = 5;
     */
    appIds: string[];
    /**
     * @generated from protobuf field: repeated string resource_type_ids = 6;
     */
    resourceTypeIds: string[];
    /**
     * @generated from protobuf field: bool exclude_immutable = 7;
     */
    excludeImmutable: boolean;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef excluded_entitlement_refs = 8;
     */
    excludedEntitlementRefs: AppEntitlementRef[];
    /**
     * @generated from protobuf oneof: recommendation
     */
    recommendation: {
        oneofKind: "all";
        /**
         * @generated from protobuf field: bool all = 10;
         */
        all: boolean;
    } | {
        oneofKind: "additions";
        /**
         * @generated from protobuf field: bool additions = 11;
         */
        additions: boolean;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementCorrelationForAccessProfileResponse
 */
export interface SearchAppEntitlementCorrelationForAccessProfileResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementCorrelation list = 1;
     */
    list: AppEntitlementCorrelation[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementUserBindingSourcesRequest
 */
export interface SearchAppEntitlementUserBindingSourcesRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string app_user_id = 3;
     */
    appUserId: string;
    /**
     * @generated from protobuf field: int32 page_size = 4;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 5;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementUserBindingSourcesResponse
 */
export interface SearchAppEntitlementUserBindingSourcesResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef list = 1;
     */
    list: AppEntitlementRef[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.CreateAutomationRequest
 */
export interface CreateAutomationRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementAutomation automation = 3;
     */
    automation?: AppEntitlementAutomation;
}
/**
 * @generated from protobuf message c1.api.app.v1.CreateAutomationResponse
 */
export interface CreateAutomationResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementAutomation automation = 1;
     */
    automation?: AppEntitlementAutomation;
}
/**
 * @generated from protobuf message c1.api.app.v1.DeleteAutomationRequest
 */
export interface DeleteAutomationRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.DeleteAutomationResponse
 */
export interface DeleteAutomationResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceCountAncestorsRequest
 */
export interface AppEntitlementSearchServiceCountAncestorsRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: uint32 depth = 3;
     */
    depth: number;
    /**
     * @generated from protobuf field: bool leaves_only = 4;
     */
    leavesOnly: boolean; // only returns nodes at the depth requested for (`depth`).
    /**
     * @generated from protobuf field: bool system_created_proxy_bindings_only = 5;
     */
    systemCreatedProxyBindingsOnly: boolean; // only follows proxy bindings created by the c1 system.
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceCountAncestorsResponse
 */
export interface AppEntitlementSearchServiceCountAncestorsResponse {
    /**
     * @generated from protobuf field: int32 count = 1;
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchAncestorsRequest
 */
export interface AppEntitlementSearchServiceSearchAncestorsRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: uint32 depth = 3;
     */
    depth: number;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 4;
     */
    expandMask?: AppEntitlementExpandMask;
    /**
     * @generated from protobuf field: bool leaves_only = 5;
     */
    leavesOnly: boolean; // only returns nodes at the depth requested for (`depth`).
    /**
     * @generated from protobuf field: bool system_created_proxy_bindings_only = 6;
     */
    systemCreatedProxyBindingsOnly: boolean; // only follows proxy bindings created by the c1 system.
    /**
     * @generated from protobuf field: int32 page_size = 7;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 8;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: bool only_ancestors_without_descendants = 9;
     */
    onlyAncestorsWithoutDescendants: boolean; // only returns ancestors that have no descendants.
}
/**
 * @generated from protobuf message c1.api.app.v1.AncestralBinding
 */
export interface AncestralBinding {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementView ancestor_entitlement = 1;
     */
    ancestorEntitlement?: AppEntitlementView;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementView descendant_entitlements = 2;
     */
    descendantEntitlements: AppEntitlementView[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AncestralBindingRef
 */
export interface AncestralBindingRef {
    /**
     * @generated from protobuf field: string ancestor_app_id = 1;
     */
    ancestorAppId: string;
    /**
     * @generated from protobuf field: string ancestor_app_entitlement_id = 2;
     */
    ancestorAppEntitlementId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchAncestorsResponse
 */
export interface AppEntitlementSearchServiceSearchAncestorsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AncestralBinding list = 1;
     */
    list: AncestralBinding[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchCountRequest
 */
export interface AppEntitlementSearchServiceSearchCountRequest {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementSearchServiceSearchRequest filter = 1;
     */
    filter?: AppEntitlementSearchServiceSearchRequest;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchCountResponse
 */
export interface AppEntitlementSearchServiceSearchCountResponse {
    /**
     * @generated from protobuf field: int64 count = 1;
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchExpiringAccessForUserRequest
 */
export interface AppEntitlementSearchServiceSearchExpiringAccessForUserRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1;
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 4;
     */
    expandMask?: AppEntitlementExpandMask;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expires_before = 5;
     */
    expiresBefore?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementWithUserBinding
 */
export interface AppEntitlementWithUserBinding {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementView entitlement = 1;
     */
    entitlement?: AppEntitlementView;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementUserView app_entitlement_user_binding = 2;
     */
    appEntitlementUserBinding?: AppEntitlementUserView;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchExpiringAccessForUserResponse
 */
export interface AppEntitlementSearchServiceSearchExpiringAccessForUserResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementWithUserBinding list = 1;
     */
    list: AppEntitlementWithUserBinding[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchGrantsRequest
 */
export interface AppEntitlementSearchServiceSearchGrantsRequest {
    /**
     * The pageSize where 0 <= pageSize <= 100. Values < 10 will be set to 10. A value of 0 returns the default page size (currently 25)
     *
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * The pageToken field.
     *
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * Control the array of expanded values that are filled out in the response to this request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 4;
     */
    expandMask?: AppEntitlementExpandMask;
    /**
     * Search for grants contained in any of these apps.
     *
     * @generated from protobuf field: repeated string app_ids = 5;
     */
    appIds: string[];
    /**
     * Search for grants that are granted to any of these app user ids.
     *
     * @generated from protobuf field: repeated string app_user_ids = 6;
     */
    appUserIds: string[];
    /**
     * Search grants for given resource types.
     *
     * @generated from protobuf field: repeated string resource_type_ids = 7;
     */
    resourceTypeIds: string[];
    /**
     * Search for grants within a resource.
     *
     * @generated from protobuf field: repeated string resource_ids = 8;
     */
    resourceIds: string[];
    /**
     * Search for grants of an entitlement
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef entitlement_refs = 9;
     */
    entitlementRefs: AppEntitlementRef[];
    /**
     * Search for grants of a user
     *
     * @generated from protobuf field: string user_id = 10;
     */
    userId: string;
    /**
     * Filter for entitlements with these purposes (e.g., ASSIGNMENT for membership entitlements)
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementPurposeValue purpose = 11;
     */
    purpose: AppEntitlementPurposeValue[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchGrantsResponse
 */
export interface AppEntitlementSearchServiceSearchGrantsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementWithUserBinding list = 1;
     */
    list: AppEntitlementWithUserBinding[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchExpiringAccessForUserCountRequest
 */
export interface AppEntitlementSearchServiceSearchExpiringAccessForUserCountRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1;
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expires_before = 2;
     */
    expiresBefore?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchExpiringAccessForUserCountResponse
 */
export interface AppEntitlementSearchServiceSearchExpiringAccessForUserCountResponse {
    /**
     * @generated from protobuf field: int64 count = 1;
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.CountGrantsExpiringBeforeRequest
 */
export interface CountGrantsExpiringBeforeRequest {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expires_before = 1;
     */
    expiresBefore?: Timestamp;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.CountGrantsExpiringBeforeResponse
 */
export interface CountGrantsExpiringBeforeResponse {
    /**
     * @generated from protobuf field: int64 count = 1;
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchGrantsExpiringBeforeRequest
 */
export interface SearchGrantsExpiringBeforeRequest {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expires_before = 1;
     */
    expiresBefore?: Timestamp;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 5;
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchGrantsExpiringBeforeResponse
 */
export interface SearchGrantsExpiringBeforeResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementWithUserBinding list = 1;
     */
    list: AppEntitlementWithUserBinding[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchTermsRequest
 */
export interface AppEntitlementSearchServiceSearchTermsRequest {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementSearchServiceSearchRequest search = 1;
     */
    search?: AppEntitlementSearchServiceSearchRequest;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementSearchServiceSearchTermsRequest.TermType term = 2;
     */
    term: AppEntitlementSearchServiceSearchTermsRequest_TermType;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: bool include_count = 4;
     */
    includeCount: boolean;
}
/**
 * @generated from protobuf enum c1.api.app.v1.AppEntitlementSearchServiceSearchTermsRequest.TermType
 */
export enum AppEntitlementSearchServiceSearchTermsRequest_TermType {
    /**
     * @generated from protobuf enum value: UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: RESOURCE_TYPE = 1;
     */
    RESOURCE_TYPE = 1,
    /**
     * @generated from protobuf enum value: APPS = 2;
     */
    APPS = 2,
    /**
     * @generated from protobuf enum value: RISK_LEVEL = 3;
     */
    RISK_LEVEL = 3,
    /**
     * @generated from protobuf enum value: COMPLIANCE_FRAMEWORK = 4;
     */
    COMPLIANCE_FRAMEWORK = 4
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchTermsResponse
 */
export interface AppEntitlementSearchServiceSearchTermsResponse {
    /**
     * @generated from protobuf field: c1.api.search.v1.Facets facets = 1;
     */
    facets?: Facets;
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * Search app entitlements by a variety of filters.
 *
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchRequest
 */
export interface AppEntitlementSearchServiceSearchRequest {
    /**
     * The pageSize where 0 <= pageSize <= 100. Values < 10 will be set to 10. A value of 0 returns the default page size (currently 25)
     *
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * The pageToken field.
     *
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * Query the app entitlements with a fuzzy search on display name and description.
     *
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * Exclude app entitlements from the results that are in these app IDs.
     *
     * @generated from protobuf field: repeated string exclude_app_ids = 4;
     */
    excludeAppIds: string[];
    /**
     * Search for app entitlements contained in any of these apps.
     *
     * @generated from protobuf field: repeated string app_ids = 5;
     */
    appIds: string[];
    /**
     * Control the array of expanded values that are filled out in the response to this request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 6;
     */
    expandMask?: AppEntitlementExpandMask;
    /**
     * Exclude app entitlements from the results that these app users have granted.
     *
     * @generated from protobuf field: repeated string exclude_app_user_ids = 7;
     */
    excludeAppUserIds: string[];
    /**
     * Search for app entitlements that are granted to any of these app user ids.
     *
     * @generated from protobuf field: repeated string app_user_ids = 8;
     */
    appUserIds: string[];
    /**
     * Search for app entitlements that are for items with resources types that have matching names. Example names are "group", "role", and "app".
     *
     * @generated from protobuf field: repeated string resource_type_ids = 10;
     */
    resourceTypeIds: string[];
    /**
     * Search for app entitlements with these risk levels.
     *
     * @generated from protobuf field: repeated string risk_level_ids = 11;
     */
    riskLevelIds: string[];
    /**
     * Search for app entitlements that are part of these compliace frameworks.
     *
     * @generated from protobuf field: repeated string compliance_framework_ids = 12;
     */
    complianceFrameworkIds: string[];
    /**
     * Search for app entitlements that belongs to these resources.
     *
     * @generated from protobuf field: repeated string resource_ids = 19;
     */
    resourceIds: string[];
    /**
     * Restrict results to only those who have expiring app entitlement user bindings.
     *
     * @generated from protobuf field: bool only_get_expiring = 15;
     */
    onlyGetExpiring: boolean;
    /**
     * Search for app entitlements that are being reviewed as part of this access review campaign.
     *
     * @generated from protobuf field: string access_review_id = 16;
     */
    accessReviewId: string;
    /**
     * Search for app entitlements that have this alias (exact match).
     *
     * @generated from protobuf field: string alias = 17;
     */
    alias: string;
    /**
     * Include deleted app entitlements, this includes app entitlements that have a deleted parent object (app, app resource, app resource type)
     *
     * @generated from protobuf field: bool include_deleted = 18;
     */
    includeDeleted: boolean;
    /**
     * @generated from protobuf field: bool is_automated = 20;
     */
    isAutomated: boolean;
    /**
     * @generated from protobuf field: repeated string resource_trait_ids = 21;
     */
    resourceTraitIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef refs = 22;
     */
    refs: AppEntitlementRef[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementMembershipType membership_type = 24;
     */
    membershipType: AppEntitlementMembershipType[];
    /**
     * @generated from protobuf field: repeated string exclude_resource_type_ids = 25;
     */
    excludeResourceTypeIds: string[];
    /**
     * @generated from protobuf field: string source_connector_id = 26;
     */
    sourceConnectorId: string;
    /**
     * @generated from protobuf field: string display_name = 27;
     */
    displayName: string;
    /**
     * @generated from protobuf field: bool exclude_immutable = 28;
     */
    excludeImmutable: boolean;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef excluded_entitlement_refs = 29;
     */
    excludedEntitlementRefs: AppEntitlementRef[];
    /**
     * Search for app entitlements that use any of these policies.
     *
     * @generated from protobuf field: repeated c1.api.policy.v1.PolicyRef policy_refs = 30;
     */
    policyRefs: PolicyRef[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchResponse
 */
export interface AppEntitlementSearchServiceSearchResponse {
    /**
     * List of app entitlement view objects.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementView list = 1;
     */
    list: AppEntitlementView[];
    /**
     * List of related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size. The server returns one page of results and the nextPageToken until all results are retreived. To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
    /**
     * Deprecated
     *
     * @generated from protobuf field: c1.api.search.v1.Facets facets = 4;
     */
    facets?: Facets;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementsWithOneOwnerRequest
 */
export interface SearchAppEntitlementsWithOneOwnerRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 3;
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementWithOneOwner
 */
export interface AppEntitlementWithOneOwner {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementView entitlement = 1;
     */
    entitlement?: AppEntitlementView;
    /**
     * @generated from protobuf field: c1.api.user.v1.User user = 2;
     */
    user?: User;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementsWithOneOwnerResponse
 */
export interface SearchAppEntitlementsWithOneOwnerResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementWithOneOwner list = 1;
     */
    list: AppEntitlementWithOneOwner[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementsWithDeactivatedOwnerRequest
 */
export interface SearchAppEntitlementsWithDeactivatedOwnerRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 3;
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementWithDeactivatedOwner
 */
export interface AppEntitlementWithDeactivatedOwner {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementView entitlement = 1;
     */
    entitlement?: AppEntitlementView;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.User entitlement_owners = 3;
     */
    entitlementOwners: User[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementsWithDeactivatedOwnerResponse
 */
export interface SearchAppEntitlementsWithDeactivatedOwnerResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementWithDeactivatedOwner list = 1;
     */
    list: AppEntitlementWithDeactivatedOwner[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementsForAppUserRequest
 */
export interface SearchAppEntitlementsForAppUserRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 3;
     */
    expandMask?: AppEntitlementExpandMask;
    /**
     * @generated from protobuf field: string app_id = 4;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 5;
     */
    appUserId: string;
    /**
     * @generated from protobuf field: repeated string resource_type_trait_ids = 6;
     */
    resourceTypeTraitIds: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementsWithRevokableForAppUserRequest
 */
export interface SearchAppEntitlementsWithRevokableForAppUserRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string app_user_id = 3;
     */
    appUserId: string;
    /**
     * @generated from protobuf field: string app_id = 4;
     */
    appId: string;
    /**
     * @generated from protobuf field: string user_id = 5;
     */
    userId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 6;
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementsWithRevokableForAppUserResponse
 */
export interface SearchAppEntitlementsWithRevokableForAppUserResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementWithRevokable list = 1;
     */
    list: AppEntitlementWithRevokable[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementWithRevokable
 */
export interface AppEntitlementWithRevokable {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementView app_entitlement = 1;
     */
    appEntitlement?: AppEntitlementView;
    /**
     * @generated from protobuf field: bool is_revokable = 2;
     */
    isRevokable: boolean;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchRequestableEntitlementsForUserRequest
 */
export interface SearchRequestableEntitlementsForUserRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string user_id = 3;
     */
    userId: string;
    /**
     * @generated from protobuf field: string app_id = 4;
     */
    appId: string;
    /**
     * @generated from protobuf field: string query = 8;
     */
    query: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 10;
     */
    expandMask?: AppEntitlementExpandMask;
    /**
     * @generated from protobuf field: c1.api.app.v1.SearchRequestableEntitlementsForUserSortBy sort_by = 11;
     */
    sortBy: SearchRequestableEntitlementsForUserSortBy;
    /**
     * @generated from protobuf field: repeated string exclude_resource_type_ids = 12;
     */
    excludeResourceTypeIds: string[];
    /**
     * @generated from protobuf field: repeated string include_resource_type_ids = 14;
     */
    includeResourceTypeIds: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchRequestableEntitlementsForUserResponse
 */
export interface SearchRequestableEntitlementsForUserResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementView list = 1;
     */
    list: AppEntitlementView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * Note only appUserId or userId can be used, not both at the same time.
 *
 * @generated from protobuf message c1.api.app.v1.RollupEntitlementsWithGrantsRequest
 */
export interface RollupEntitlementsWithGrantsRequest {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef entitlements = 1;
     */
    entitlements: AppEntitlementRef[];
    /**
     * @generated from protobuf field: string app_user_id = 2;
     */
    appUserId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementUserBindingRef refs = 5;
     */
    refs: AppEntitlementUserBindingRef[];
    /**
     * @generated from protobuf field: string user_id = 6;
     */
    userId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.RollupEntitlementsWithGrantsResponse
 */
export interface RollupEntitlementsWithGrantsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementUserBinding list = 1;
     */
    list: AppEntitlementUserBinding[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * The app entitlement represents one permission in a downstream App (SAAS) that can be granted. For example, GitHub Read vs GitHub Write.
 *
 * @generated from protobuf message c1.api.app.v1.AppEntitlement
 */
export interface AppEntitlement {
    /**
     * The ID of the app that is associated with the app entitlement.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The unique ID for the App Entitlement.
     *
     * @generated from protobuf field: string id = 2;
     */
    id: string;
    /**
     * The datetime, in RFC3339 format, of when the AppEntitlement was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3;
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the AppEntitlement was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4;
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the AppEntitlement was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5;
     */
    deletedAt?: Timestamp;
    /**
     * The display name of the app entitlement.
     *
     * @generated from protobuf field: string display_name = 6;
     */
    displayName: string;
    /**
     * The description of the app entitlement.
     *
     * @generated from protobuf field: string description = 7;
     */
    description: string;
    /**
     * @generated from protobuf oneof: max_grant_duration
     */
    maxGrantDuration: {
        oneofKind: "durationUnset";
        /**
         * If grants for this app entitlement do not have a max duration this field is set with {}.
         *
         * @generated from protobuf field: google.protobuf.Empty duration_unset = 10;
         */
        durationUnset: Empty;
    } | {
        oneofKind: "durationGrant";
        /**
         * If grants for this app entitlement have a max duration this field is set with the max duration in seconds.
         *
         * @generated from protobuf field: google.protobuf.Duration duration_grant = 11;
         */
        durationGrant: Duration;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: string risk_level_value_id = 13;
     */
    riskLevelValueId: string;
    /**
     * The IDs of different compliance frameworks associated with this app entitlement ex (SOX, HIPAA, PCI, etc.)
     *
     * @generated from protobuf field: repeated string compliance_framework_value_ids = 14;
     */
    complianceFrameworkValueIds: string[];
    /**
     * The ID of the policy that will be used for grant tickets related to the app entitlement.
     *
     * @generated from protobuf field: string grant_policy_id = 17;
     */
    grantPolicyId: string;
    /**
     * The ID of the policy that will be used for revoke tickets related to the app entitlement
     *
     * @generated from protobuf field: string revoke_policy_id = 18;
     */
    revokePolicyId: string;
    /**
     * The ID of the policy that will be used for certify tickets related to the app entitlement.
     *
     * @generated from protobuf field: string certify_policy_id = 19;
     */
    certifyPolicyId: string;
    /**
     * The ID of the policy that will be used for emergency access grant tasks.
     *
     * @generated from protobuf field: string emergency_grant_policy_id = 27;
     */
    emergencyGrantPolicyId: string;
    /**
     * This enables tasks to be created in an emergency and use a selected emergency access policy.
     *
     * @generated from protobuf field: bool emergency_grant_enabled = 28;
     */
    emergencyGrantEnabled: boolean;
    /**
     * The amount of grants open for this entitlement
     *
     * @generated from protobuf field: int64 grant_count = 20;
     */
    grantCount: number;
    /**
     * The provision policy used by approved grant and revoke tasks.
     *
     * @generated from protobuf field: c1.api.policy.v1.ProvisionPolicy provisioner_policy = 21;
     */
    provisionerPolicy?: ProvisionPolicy;
    /**
     * The ID of the app resource type that is associated with the app entitlement
     *
     * @generated from protobuf field: string app_resource_type_id = 22;
     */
    appResourceTypeId: string;
    /**
     * The ID of the app resource that is associated with the app entitlement
     *
     * @generated from protobuf field: string app_resource_id = 23;
     */
    appResourceId: string;
    /**
     * This field indicates if this is a system builtin entitlement.
     *
     * @generated from protobuf field: bool system_builtin = 24;
     */
    systemBuiltin: boolean;
    /**
     * The slug is displayed as an oval next to the name in the frontend of C1, it tells you what permission the entitlement grants. See https://www.conductorone.com/docs/product/admin/entitlements/
     *
     * @generated from protobuf field: string slug = 25;
     */
    slug: string;
    /**
     * The alias of the app entitlement used by Cone. Also exact-match queryable.
     *
     * @generated from protobuf field: string alias = 26;
     */
    alias: string;
    /**
     * The fields that have been edited by a user.
     *
     * @generated from protobuf field: google.protobuf.FieldMask user_edited_mask = 29;
     */
    userEditedMask?: FieldMask;
    /**
     * Flag to indicate if the app entitlement is manually managed.
     *
     * @generated from protobuf field: bool is_manually_managed = 30;
     */
    isManuallyManaged: boolean;
    /**
     * Map to tell us which connector the entitlement came from.
     *
     * @generated from protobuf field: map<string, string> source_connector_ids = 31;
     */
    sourceConnectorIds: {
        [key: string]: string;
    };
    /**
     * Flag to indicate if the app-level access request settings have been overridden for the entitlement
     *
     * @generated from protobuf field: bool override_access_requests_defaults = 32;
     */
    overrideAccessRequestsDefaults: boolean;
    /**
     * Flag to indicate if app-level access request defaults have been applied to the entitlement
     *
     * @generated from protobuf field: bool default_values_applied = 33;
     */
    defaultValuesApplied: boolean;
    /**
     * Flag to indicate whether automation (for adding users to entitlement based on rules) has been enabled.
     *
     * @generated from protobuf field: bool is_automation_enabled = 39;
     */
    isAutomationEnabled: boolean;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementPurposeValue purpose = 40;
     */
    purpose: AppEntitlementPurposeValue;
    /**
     * The deprovision policy used by approved revoke tasks (for access entitlements only).
     *
     * @generated from protobuf field: c1.api.policy.v1.ProvisionPolicy deprovisioner_policy = 41;
     */
    deprovisionerPolicy?: ProvisionPolicy;
    /**
     * @generated from protobuf field: string match_baton_id = 42;
     */
    matchBatonId: string;
    /**
     * The ID of the request schema associated with this app entitlement.
     *
     * @generated from protobuf field: string request_schema_id = 43;
     */
    requestSchemaId: string;
}
/**
 * The app entitlement view contains the serialized app entitlement and paths to objects referenced by the app entitlement.
 *
 * @generated from protobuf message c1.api.app.v1.AppEntitlementView
 */
export interface AppEntitlementView {
    /**
     * The serialized app entitlement.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlement app_entitlement = 1;
     */
    appEntitlement?: AppEntitlement;
    /**
     * JSONPATH expression indicating the location of the App object in the  array.
     *
     * @generated from protobuf field: string app_path = 2;
     */
    appPath: string;
    /**
     * JSONPATH expression indicating the location of the App Resource object in the  array.
     *
     * @generated from protobuf field: string app_resource_type_path = 3;
     */
    appResourceTypePath: string;
    /**
     * JSONPATH expression indicating the location of the App Resource Type object in the expanded array.
     *
     * @generated from protobuf field: string app_resource_path = 4;
     */
    appResourcePath: string;
    /**
     * The permissions the current user has on this entitlement's parent resource.
     *
     * @generated from protobuf field: c1.api.iam.v1.ActorObjectPermissions object_permissions = 5;
     */
    objectPermissions?: ActorObjectPermissions;
}
/**
 * @generated from protobuf message c1.api.app.v1.CatalogEntry
 */
export interface CatalogEntry {
    /**
     * The serialized app entitlement.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlement app_entitlement = 1;
     */
    appEntitlement?: AppEntitlement;
    /**
     * JSONPATH expression indicating the location of the App object in the  array.
     *
     * @generated from protobuf field: string app_path = 2;
     */
    appPath: string;
    /**
     * JSONPATH expression indicating the location of the App Resource object in the  array.
     *
     * @generated from protobuf field: string app_resource_type_path = 3;
     */
    appResourceTypePath: string;
    /**
     * JSONPATH expression indicating the location of the App Resource Type object in the expanded array.
     *
     * @generated from protobuf field: string app_resource_path = 4;
     */
    appResourcePath: string;
    /**
     * Count of grants of this entitlement to members of this catalog
     *
     * @generated from protobuf field: int64 enrolled_members_count = 5;
     */
    enrolledMembersCount: number;
    /**
     * Total count of members of this catalog
     *
     * @generated from protobuf field: int64 total_members_count = 6;
     */
    totalMembersCount: number;
}
/**
 * The app entitlement expand mask allows the user to get additional information when getting responses containing app entitlement views.
 *
 * @generated from protobuf message c1.api.app.v1.AppEntitlementExpandMask
 */
export interface AppEntitlementExpandMask {
    /**
     * Array of strings to describe which items to expand on the return value. Can be any combination of "*", "app_id", "app_resource_type_id", or "app_resource_id".
     *
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.CreateAppEntitlementRequest
 */
export interface CreateAppEntitlementRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 4;
     */
    expandMask?: AppEntitlementExpandMask;
    /**
     * @generated from protobuf field: string app_resource_type_id = 5;
     */
    appResourceTypeId: string;
    /**
     * @generated from protobuf field: string app_resource_id = 6;
     */
    appResourceId: string;
    /**
     * @generated from protobuf field: string slug = 7;
     */
    slug: string;
    /**
     * @generated from protobuf field: repeated string app_entitlement_owner_ids = 8;
     */
    appEntitlementOwnerIds: string[];
    /**
     * @generated from protobuf field: bool emergency_grant_enabled = 9;
     */
    emergencyGrantEnabled: boolean;
    /**
     * @generated from protobuf field: string emergency_grant_policy_id = 10;
     */
    emergencyGrantPolicyId: string;
    /**
     * @generated from protobuf field: string grant_policy_id = 11;
     */
    grantPolicyId: string;
    /**
     * @generated from protobuf field: string revoke_policy_id = 12;
     */
    revokePolicyId: string;
    /**
     * @generated from protobuf field: string certify_policy_id = 13;
     */
    certifyPolicyId: string;
    /**
     * @generated from protobuf field: string risk_level_value_id = 14;
     */
    riskLevelValueId: string;
    /**
     * @generated from protobuf field: repeated string compliance_framework_value_ids = 15;
     */
    complianceFrameworkValueIds: string[];
    /**
     * @generated from protobuf field: string alias = 16;
     */
    alias: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementPurposeValue purpose = 17;
     */
    purpose: AppEntitlementPurposeValue;
    /**
     * @generated from protobuf field: c1.api.policy.v1.ProvisionPolicy provision_policy = 18;
     */
    provisionPolicy?: ProvisionPolicy;
    /**
     * @generated from protobuf oneof: max_grant_duration
     */
    maxGrantDuration: {
        oneofKind: "durationUnset";
        /**
         * If grants for this app entitlement do not have a max duration this field is set with {}.
         *
         * @generated from protobuf field: google.protobuf.Empty duration_unset = 19;
         */
        durationUnset: Empty;
    } | {
        oneofKind: "durationGrant";
        /**
         * If grants for this app entitlement have a max duration this field is set with the max duration in seconds.
         *
         * @generated from protobuf field: google.protobuf.Duration duration_grant = 20;
         */
        durationGrant: Duration;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: bool override_access_requests_defaults = 21;
     */
    overrideAccessRequestsDefaults: boolean;
    /**
     * If supplied, it's implied that the entitlement is created before sync and needs to be merged with connector entitlement.
     *
     * @generated from protobuf field: string match_baton_id = 22;
     */
    matchBatonId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.CreateAppEntitlementResponse
 */
export interface CreateAppEntitlementResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementView app_entitlement_view = 1;
     */
    appEntitlementView?: AppEntitlementView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * The UpdateAppEntitlementRequest message contains the app entitlement and the fields to be updated.
 *
 * @generated from protobuf message c1.api.app.v1.UpdateAppEntitlementRequest
 */
export interface UpdateAppEntitlementRequest {
    /**
     * The ID of the app that is associated with the app entitlement.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The fields of this app entitlement being updated by this request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlement entitlement = 2;
     */
    entitlement?: AppEntitlement;
    /**
     * A comma sepparated list of fields to update from the entitlement. For example: "certify_policy_id,slug"
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 3;
     */
    updateMask?: FieldMask;
    /**
     * The fields of this app entitlement being updated by this request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 4;
     */
    expandMask?: AppEntitlementExpandMask;
    /**
     * Flag to indicate that access request defaults, if any are applied to these entitlements, should be overridden.
     *
     * @generated from protobuf field: bool override_access_requests_defaults = 5;
     */
    overrideAccessRequestsDefaults: boolean;
}
/**
 * The UpdateProvisionerPolicyAppEntitlementRequest message contains the app entitlement and the fields to be updated.
 *
 * @generated from protobuf message c1.api.app.v1.UpdateProvisionerPolicyAppEntitlementRequest
 */
export interface UpdateProvisionerPolicyAppEntitlementRequest {
    /**
     * The ID of the app that is associated with the app entitlement.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The fields of this app entitlement being updated by this request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlement entitlement = 2;
     */
    entitlement?: AppEntitlement;
    /**
     * The fields of this app entitlement being updated by this request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 4;
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * The UpdateDeprovisionerPolicyAppEntitlementRequest message contains the app entitlement and the fields to be updated.
 *
 * @generated from protobuf message c1.api.app.v1.UpdateDeprovisionerPolicyAppEntitlementRequest
 */
export interface UpdateDeprovisionerPolicyAppEntitlementRequest {
    /**
     * The ID of the app that is associated with the app entitlement.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The fields of this app entitlement being updated by this request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlement entitlement = 2;
     */
    entitlement?: AppEntitlement;
    /**
     * The fields of this app entitlement being updated by this request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 4;
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.UpdateAppEntitlementResponse
 */
export interface UpdateAppEntitlementResponse {
    /**
     * A view of the updated app entitlement contains the serialized app entitlement and paths to objects referenced by the app entitlement.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementView app_entitlement_view = 1;
     */
    appEntitlementView?: AppEntitlementView;
    /**
     * List of related objects
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.GetAppEntitlementRequest
 */
export interface GetAppEntitlementRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 3;
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * The get app entitlement response returns an entitlement view containing paths in the expanded array for the objects expanded as indicated by the expand mask in the request.
 *
 * @generated from protobuf message c1.api.app.v1.GetAppEntitlementResponse
 */
export interface GetAppEntitlementResponse {
    /**
     * A view of the app entitlement, contains the serialized app entitlement and paths to objects referenced by the app entitlement.
     *
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementView app_entitlement_view = 1;
     */
    appEntitlementView?: AppEntitlementView;
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.BulkGetAppEntitlementsRequest
 */
export interface BulkGetAppEntitlementsRequest {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 1;
     */
    appEntitlementRefs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.app.v1.BulkGetAppEntitlementsResponse
 */
export interface BulkGetAppEntitlementsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlement list = 1;
     */
    list: AppEntitlement[];
}
/**
 * @generated from protobuf message c1.api.app.v1.DeleteAppEntitlementRequest
 */
export interface DeleteAppEntitlementRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.DeleteAppEntitlementResponse
 */
export interface DeleteAppEntitlementResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.DeleteAppEntitlementIfManuallyCreatedRequest
 */
export interface DeleteAppEntitlementIfManuallyCreatedRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppEntitlementsRequest
 */
export interface ListAppEntitlementsRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 4;
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * The ListAppEntitlementsResponse message contains a list of results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.app.v1.ListAppEntitlementsResponse
 */
export interface ListAppEntitlementsResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementView list = 1;
     */
    list: AppEntitlementView[];
    /**
     * List of related objects
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size. The server returns one page of results and the nextPageToken until all results are retreived. To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * The AppEntitlementUserView (aka grant view) describes the relationship between an app user and an entitlement. They have more recently been referred to as grants.
 *
 * @generated from protobuf message c1.api.app.v1.AppEntitlementUserView
 */
export interface AppEntitlementUserView {
    /**
     * The app user referenced by this app entitlement user (grant).
     *
     * @generated from protobuf field: c1.api.app.v1.AppUserView app_user = 1;
     */
    appUser?: AppUserView;
    /**
     * When the app entitlement user binding (grant) was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp app_entitlement_user_binding_created_at = 2;
     */
    appEntitlementUserBindingCreatedAt?: Timestamp;
    /**
     * When the app entitlement user binding (grant) intends to deprovision.
     *
     * @generated from protobuf field: google.protobuf.Timestamp app_entitlement_user_binding_deprovision_at = 3;
     */
    appEntitlementUserBindingDeprovisionAt?: Timestamp;
    /**
     * List of sources for the grant, ie. groups, roles, etc.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef grant_sources = 4;
     */
    grantSources: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppEntitlementUsersRequest
 */
export interface ListAppEntitlementUsersRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUserExpandMask expand_mask = 5;
     */
    expandMask?: AppUserExpandMask;
}
/**
 * The ListAppEntitlementUsersResponse message contains a list of results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.app.v1.ListAppEntitlementUsersResponse
 */
export interface ListAppEntitlementUsersResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementUserView list = 1;
     */
    list: AppEntitlementUserView[];
    /**
     * List of related objects
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size. The server returns one page of results and the nextPageToken until all results are retreived. To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementsWithExpiredRequest
 */
export interface SearchAppEntitlementsWithExpiredRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementUserBindingRef refs = 6;
     */
    refs: AppEntitlementUserBindingRef[];
    /**
     * @generated from protobuf field: string query = 7;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserRef app_user_refs = 8;
     */
    appUserRefs: AppUserRef[];
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.UserRef user_refs = 9;
     */
    userRefs: UserRef[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementWithExpired
 */
export interface AppEntitlementWithExpired {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUser app_user = 1;
     */
    appUser?: AppUser;
    /**
     * @generated from protobuf field: c1.api.user.v1.User user = 2;
     */
    user?: User;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp expired = 3;
     */
    expired?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp discovered = 4;
     */
    discovered?: Timestamp;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.GrantReason grant_reasons = 5;
     */
    grantReasons: GrantReason[];
    /**
     * @generated from protobuf field: string app_entitlement_id = 6;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string app_id = 7;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 8;
     */
    appUserId: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef grant_sources = 9;
     */
    grantSources: AppEntitlementRef[];
}
/**
 * The SearchAppEntitlementsWithExpiredResponse message contains a list of results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.app.v1.SearchAppEntitlementsWithExpiredResponse
 */
export interface SearchAppEntitlementsWithExpiredResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementWithExpired list = 1;
     */
    list: AppEntitlementWithExpired[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppEntitlementsForAppUserRequest
 */
export interface ListAppEntitlementsForAppUserRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_user_id = 2;
     */
    appUserId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 5;
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppEntitlementGroupsRequest
 */
export interface ListAppEntitlementGroupsRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
}
/**
 * The ListAppEntitlementGroupsResponse message contains a list of results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.app.v1.ListAppEntitlementGroupsResponse
 */
export interface ListAppEntitlementGroupsResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppGroup list = 1;
     */
    list: AppGroup[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size. The server returns one page of results and the nextPageToken until all results are retreived. To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * Deprecated
     *
     * @generated from protobuf field: string notification_token = 3;
     */
    notificationToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAppEntitlementsForAppResourceRequest
 */
export interface ListAppEntitlementsForAppResourceRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_resource_type_id = 2;
     */
    appResourceTypeId: string;
    /**
     * @generated from protobuf field: string app_resource_id = 3;
     */
    appResourceId: string;
    /**
     * @generated from protobuf field: int32 page_size = 4;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 5;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementExpandMask expand_mask = 6;
     */
    expandMask?: AppEntitlementExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppWithGrantCount
 */
export interface AppWithGrantCount {
    /**
     * @generated from protobuf field: c1.api.app.v1.App App = 1 [json_name = "App"];
     */
    app?: App;
    /**
     * @generated from protobuf field: int64 Count = 2 [json_name = "Count"];
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.CountStandingHighRiskGrantsRequest
 */
export interface CountStandingHighRiskGrantsRequest {
}
/**
 * @generated from protobuf message c1.api.app.v1.CountStandingHighRiskGrantsResponse
 */
export interface CountStandingHighRiskGrantsResponse {
    /**
     * @generated from protobuf field: int64 total_count = 1;
     */
    totalCount: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchStandingHighRiskGrantsForAppsRequest
 */
export interface SearchStandingHighRiskGrantsForAppsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchStandingHighRiskGrantsForAppsResponse
 */
export interface SearchStandingHighRiskGrantsForAppsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppWithGrantCount list = 1;
     */
    list: AppWithGrantCount[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementAutomationRef
 */
export interface AppEntitlementAutomationRef {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementServiceGetAutomationRequest
 */
export interface AppEntitlementServiceGetAutomationRequest {
    /**
     * The ID of the app that is associated with the app entitlement.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The unique ID for the App Entitlement.
     *
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementServiceGetAutomationResponse
 */
export interface AppEntitlementServiceGetAutomationResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementAutomation AppEntitlementAutomation = 1 [json_name = "AppEntitlementAutomation"];
     */
    appEntitlementAutomation?: AppEntitlementAutomation;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementServicePreviewAutomationCELRequest
 */
export interface AppEntitlementServicePreviewAutomationCELRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string expression = 3;
     */
    expression: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse
 */
export interface AppEntitlementServicePreviewAutomationCELResponse {
    /**
     * @generated from protobuf oneof: response
     */
    response: {
        oneofKind: "matched";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse.PreviewAutomationCELResponseMatched matched = 1;
         */
        matched: AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseMatched;
    } | {
        oneofKind: "status";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse.PreviewAutomationCELResponseStatus status = 2;
         */
        status: AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseStatus;
    } | {
        oneofKind: "failed";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse.PreviewAutomationCELResponseFailed failed = 3;
         */
        failed: AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseFailed;
    } | {
        oneofKind: "stopped";
        /**
         * @generated from protobuf field: bool stopped = 4;
         */
        stopped: boolean;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse.PreviewAutomationCELResponseMatched
 */
export interface AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseMatched {
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.User list = 1;
     */
    list: User[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse.PreviewAutomationCELResponseFailed
 */
export interface AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseFailed {
    /**
     * @generated from protobuf field: c1.api.user.v1.User user = 1;
     */
    user?: User;
    /**
     * @generated from protobuf field: string error = 2;
     */
    error: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse.PreviewAutomationCELResponseStatus
 */
export interface AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseStatus {
    /**
     * @generated from protobuf field: int64 total = 1;
     */
    total: number;
    /**
     * @generated from protobuf field: int64 scanned = 2;
     */
    scanned: number;
    /**
     * @generated from protobuf field: int64 matched = 3;
     */
    matched: number;
    /**
     * @generated from protobuf field: int64 errors = 4;
     */
    errors: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementServiceUpdateAutomationRequest
 */
export interface AppEntitlementServiceUpdateAutomationRequest {
    /**
     * The ID of the app that is associated with the app entitlement.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The unique ID for the App Entitlement.
     *
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * The display name of the app entitlement.
     *
     * @generated from protobuf field: string display_name = 3;
     */
    displayName: string;
    /**
     * The description of the app entitlement.
     *
     * @generated from protobuf field: string description = 4;
     */
    description: string;
    /**
     * @generated from protobuf oneof: conditions
     */
    conditions: {
        oneofKind: "none";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppEntitlementAutomationRuleNone none = 100;
         */
        none: AppEntitlementAutomationRuleNone;
    } | {
        oneofKind: "entitlements";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppEntitlementAutomationRuleEntitlement entitlements = 101;
         */
        entitlements: AppEntitlementAutomationRuleEntitlement;
    } | {
        oneofKind: "cel";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppEntitlementAutomationRuleCEL cel = 102;
         */
        cel: AppEntitlementAutomationRuleCEL;
    } | {
        oneofKind: "basic";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppEntitlementAutomationRuleBasic basic = 103;
         */
        basic: AppEntitlementAutomationRuleBasic;
    } | {
        oneofKind: undefined;
    };
    /**
     * The comma-sepparated list of fields to update in the view. "display_name,description"
     * would update display name and description regardless of what values are set on the request object.
     *
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 5;
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementServiceUpdateAutomationResponse
 */
export interface AppEntitlementServiceUpdateAutomationResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementAutomation AppEntitlementAutomation = 1 [json_name = "AppEntitlementAutomation"];
     */
    appEntitlementAutomation?: AppEntitlementAutomation;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementAutomationRuleNone
 */
export interface AppEntitlementAutomationRuleNone {
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementAutomationRuleEntitlement
 */
export interface AppEntitlementAutomationRuleEntitlement {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef entitlement_refs = 1;
     */
    entitlementRefs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementAutomationRuleCEL
 */
export interface AppEntitlementAutomationRuleCEL {
    /**
     * @generated from protobuf field: string expression = 1;
     */
    expression: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementAutomationRuleBasic
 */
export interface AppEntitlementAutomationRuleBasic {
    /**
     * @generated from protobuf field: string expression = 1;
     */
    expression: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementAutomationLastRunStatus
 */
export interface AppEntitlementAutomationLastRunStatus {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_completed_at = 1;
     */
    lastCompletedAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementAutomationRunStatus status = 2;
     */
    status: AppEntitlementAutomationRunStatus;
    /**
     * @generated from protobuf field: string error_message = 3;
     */
    errorMessage: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementAutomation
 */
export interface AppEntitlementAutomation {
    /**
     * The ID of the app that is associated with the app entitlement.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The unique ID for the App Entitlement.
     *
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * The datetime, in RFC3339 format, of when the AppEntitlement was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3;
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the AppEntitlement was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4;
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the AppEntitlement was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5;
     */
    deletedAt?: Timestamp;
    /**
     * The display name of the app entitlement.
     *
     * @generated from protobuf field: string display_name = 6;
     */
    displayName: string;
    /**
     * The description of the app entitlement.
     *
     * @generated from protobuf field: string description = 7;
     */
    description: string;
    /**
     * @generated from protobuf oneof: conditions
     */
    conditions: {
        oneofKind: "none";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppEntitlementAutomationRuleNone none = 100;
         */
        none: AppEntitlementAutomationRuleNone;
    } | {
        oneofKind: "entitlements";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppEntitlementAutomationRuleEntitlement entitlements = 101;
         */
        entitlements: AppEntitlementAutomationRuleEntitlement;
    } | {
        oneofKind: "cel";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppEntitlementAutomationRuleCEL cel = 102;
         */
        cel: AppEntitlementAutomationRuleCEL;
    } | {
        oneofKind: "basic";
        /**
         * @generated from protobuf field: c1.api.app.v1.AppEntitlementAutomationRuleBasic basic = 103;
         */
        basic: AppEntitlementAutomationRuleBasic;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementAutomationLastRunStatus last_run_status = 8;
     */
    lastRunStatus?: AppEntitlementAutomationLastRunStatus;
}
/**
 * @generated from protobuf message c1.api.app.v1.AddAutomationExclusionRequest
 */
export interface AddAutomationExclusionRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: repeated string user_ids = 3;
     */
    userIds: string[];
}
/**
 * Empty response with a status code indicating success.
 *
 * @generated from protobuf message c1.api.app.v1.AddAutomationExclusionResponse
 */
export interface AddAutomationExclusionResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.RemoveAutomationExclusionRequest
 */
export interface RemoveAutomationExclusionRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: repeated string user_ids = 3;
     */
    userIds: string[];
}
/**
 * Empty response with a status code indicating success.
 *
 * @generated from protobuf message c1.api.app.v1.RemoveAutomationExclusionResponse
 */
export interface RemoveAutomationExclusionResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAutomationExclusionsRequest
 */
export interface ListAutomationExclusionsRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: int32 page_size = 3;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 4;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementUserBindingRef refs = 6;
     */
    refs: AppEntitlementUserBindingRef[];
}
/**
 * @generated from protobuf message c1.api.app.v1.UserWithAppEntitlementUserBindingView
 */
export interface UserWithAppEntitlementUserBindingView {
    /**
     * @generated from protobuf field: c1.api.user.v1.User user = 1;
     */
    user?: User;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 3;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string app_user_id = 4;
     */
    appUserId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ListAutomationExclusionsResponse
 */
export interface ListAutomationExclusionsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.UserWithAppEntitlementUserBindingView list = 1;
     */
    list: UserWithAppEntitlementUserBindingView[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AddManuallyManagedUsersRequest
 */
export interface AddManuallyManagedUsersRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: repeated string user_ids = 3;
     */
    userIds: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.ManuallyManagedUsersResponse
 */
export interface ManuallyManagedUsersResponse {
    /**
     * @generated from protobuf field: map<string, string> failed_users_error_map = 1;
     */
    failedUsersErrorMap: {
        [key: string]: string;
    };
}
/**
 * @generated from protobuf message c1.api.app.v1.RemoveEntitlementMembershipRequest
 */
export interface RemoveEntitlementMembershipRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_entitlement_id = 2;
     */
    appEntitlementId: string;
    /**
     * @generated from protobuf field: string app_user_id = 3;
     */
    appUserId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.RemoveEntitlementMembershipResponse
 */
export interface RemoveEntitlementMembershipResponse {
    /**
     * The ID of the revoke task created to remove the user from the entitlement, if the entitlement is an access profile (aka. catalog).
     * It's aka. the JML task.
     *
     * @generated from protobuf field: string revoke_task_id = 1;
     */
    revokeTaskId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ForceRunDynamicGroupAutomationRequest
 */
export interface ForceRunDynamicGroupAutomationRequest {
    /**
     * @generated from protobuf field: string app_entitlement_id = 1;
     */
    appEntitlementId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.ForceRunDynamicGroupAutomationResponse
 */
export interface ForceRunDynamicGroupAutomationResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementSearchFilter
 */
export interface AppEntitlementSearchFilter {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementRef app_entitlement_refs = 12;
     */
    appEntitlementRefs: AppEntitlementRef[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppEntitlementUserBindingSearchFilter
 */
export interface AppEntitlementUserBindingSearchFilter {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementUserBindingRef refs = 1;
     */
    refs: AppEntitlementUserBindingRef[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserRef app_user_refs = 2;
     */
    appUserRefs: AppUserRef[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlementUserBindingRef exclude_refs = 3;
     */
    excludeRefs: AppEntitlementUserBindingRef[];
}
/**
 * @generated from protobuf enum c1.api.app.v1.AppEntitlementMembershipType
 */
export enum AppEntitlementMembershipType {
    /**
     * @generated from protobuf enum value: APP_ENTITLEMENT_MEMBERSHIP_TYPE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: APP_ENTITLEMENT_MEMBERSHIP_TYPE_MEMBER = 1;
     */
    MEMBER = 1,
    /**
     * @generated from protobuf enum value: APP_ENTITLEMENT_MEMBERSHIP_TYPE_OWNER = 2;
     */
    OWNER = 2,
    /**
     * @generated from protobuf enum value: APP_ENTITLEMENT_MEMBERSHIP_TYPE_EXCLUSION = 3;
     */
    EXCLUSION = 3,
    /**
     * @generated from protobuf enum value: APP_ENTITLEMENT_MEMBERSHIP_TYPE_ADMIN = 4;
     */
    ADMIN = 4
}
/**
 * AppEntitlementSortBy defines the various fields that AppEntitlements can be sorted by
 *
 * @generated from protobuf enum c1.api.app.v1.SearchRequestableEntitlementsForUserSortBy
 */
export enum SearchRequestableEntitlementsForUserSortBy {
    /**
     * Default sorting behavior (unspecified)
     *
     * @generated from protobuf enum value: SORT_BY_UNSPECIFIED = 0;
     */
    SORT_BY_UNSPECIFIED = 0,
    /**
     * Sort by resource type display name, resource display name
     *
     * @generated from protobuf enum value: SORT_BY_RESOURCE_TYPE_AND_RESOURCE = 1;
     */
    SORT_BY_RESOURCE_TYPE_AND_RESOURCE = 1
}
/**
 * @generated from protobuf enum c1.api.app.v1.AppEntitlementPurposeValue
 */
export enum AppEntitlementPurposeValue {
    /**
     * @generated from protobuf enum value: APP_ENTITLEMENT_PURPOSE_VALUE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: APP_ENTITLEMENT_PURPOSE_VALUE_ASSIGNMENT = 1;
     */
    ASSIGNMENT = 1,
    /**
     * @generated from protobuf enum value: APP_ENTITLEMENT_PURPOSE_VALUE_PERMISSION = 2;
     */
    PERMISSION = 2,
    /**
     * @generated from protobuf enum value: APP_ENTITLEMENT_PURPOSE_VALUE_OWNERSHIP = 3;
     */
    OWNERSHIP = 3
}
/**
 * @generated from protobuf enum c1.api.app.v1.AppEntitlementAutomationRunStatus
 */
export enum AppEntitlementAutomationRunStatus {
    /**
     * @generated from protobuf enum value: APP_ENTITLEMENT_AUTOMATION_RUN_STATUS_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: APP_ENTITLEMENT_AUTOMATION_RUN_STATUS_SUCCESS = 1;
     */
    SUCCESS = 1,
    /**
     * @generated from protobuf enum value: APP_ENTITLEMENT_AUTOMATION_RUN_STATUS_FAILED = 2;
     */
    FAILED = 2,
    /**
     * @generated from protobuf enum value: APP_ENTITLEMENT_AUTOMATION_RUN_STATUS_IN_PROGRESS = 3;
     */
    IN_PROGRESS = 3
}
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementUserBindingDestinationsRequest$Type extends MessageType<SearchAppEntitlementUserBindingDestinationsRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementUserBindingDestinationsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 5, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementUserBindingDestinationsRequest
 */
export const SearchAppEntitlementUserBindingDestinationsRequest = new SearchAppEntitlementUserBindingDestinationsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementUserBindingDestinationsResponse$Type extends MessageType<SearchAppEntitlementUserBindingDestinationsResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementUserBindingDestinationsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementUserBindingDestinationsResponse
 */
export const SearchAppEntitlementUserBindingDestinationsResponse = new SearchAppEntitlementUserBindingDestinationsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementCorrelation$Type extends MessageType<AppEntitlementCorrelation> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementCorrelation", [
            { no: 1, name: "app_entitlement", kind: "message", T: () => AppEntitlementRef },
            { no: 2, name: "distance", kind: "scalar", opt: true, T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementCorrelation
 */
export const AppEntitlementCorrelation = new AppEntitlementCorrelation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementCorrelationForAccessProfileRequest$Type extends MessageType<SearchAppEntitlementCorrelationForAccessProfileRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementCorrelationForAccessProfileRequest", [
            { no: 1, name: "access_profile_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } },
            { no: 7, name: "exclude_immutable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 8, name: "excluded_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 10, name: "all", kind: "scalar", oneof: "recommendation", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "additions", kind: "scalar", oneof: "recommendation", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementCorrelationForAccessProfileRequest
 */
export const SearchAppEntitlementCorrelationForAccessProfileRequest = new SearchAppEntitlementCorrelationForAccessProfileRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementCorrelationForAccessProfileResponse$Type extends MessageType<SearchAppEntitlementCorrelationForAccessProfileResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementCorrelationForAccessProfileResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementCorrelation },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementCorrelationForAccessProfileResponse
 */
export const SearchAppEntitlementCorrelationForAccessProfileResponse = new SearchAppEntitlementCorrelationForAccessProfileResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementUserBindingSourcesRequest$Type extends MessageType<SearchAppEntitlementUserBindingSourcesRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementUserBindingSourcesRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 5, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementUserBindingSourcesRequest
 */
export const SearchAppEntitlementUserBindingSourcesRequest = new SearchAppEntitlementUserBindingSourcesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementUserBindingSourcesResponse$Type extends MessageType<SearchAppEntitlementUserBindingSourcesResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementUserBindingSourcesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementUserBindingSourcesResponse
 */
export const SearchAppEntitlementUserBindingSourcesResponse = new SearchAppEntitlementUserBindingSourcesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAutomationRequest$Type extends MessageType<CreateAutomationRequest> {
    constructor() {
        super("c1.api.app.v1.CreateAutomationRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "automation", kind: "message", T: () => AppEntitlementAutomation, options: { "validate.rules": { message: { required: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CreateAutomationRequest
 */
export const CreateAutomationRequest = new CreateAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAutomationResponse$Type extends MessageType<CreateAutomationResponse> {
    constructor() {
        super("c1.api.app.v1.CreateAutomationResponse", [
            { no: 1, name: "automation", kind: "message", T: () => AppEntitlementAutomation }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CreateAutomationResponse
 */
export const CreateAutomationResponse = new CreateAutomationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAutomationRequest$Type extends MessageType<DeleteAutomationRequest> {
    constructor() {
        super("c1.api.app.v1.DeleteAutomationRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAutomationRequest
 */
export const DeleteAutomationRequest = new DeleteAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAutomationResponse$Type extends MessageType<DeleteAutomationResponse> {
    constructor() {
        super("c1.api.app.v1.DeleteAutomationResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAutomationResponse
 */
export const DeleteAutomationResponse = new DeleteAutomationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceCountAncestorsRequest$Type extends MessageType<AppEntitlementSearchServiceCountAncestorsRequest> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceCountAncestorsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "depth", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "validate.rules": { uint32: { lte: 2, gte: 1, ignoreEmpty: true } } } },
            { no: 4, name: "leaves_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "system_created_proxy_bindings_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceCountAncestorsRequest
 */
export const AppEntitlementSearchServiceCountAncestorsRequest = new AppEntitlementSearchServiceCountAncestorsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceCountAncestorsResponse$Type extends MessageType<AppEntitlementSearchServiceCountAncestorsResponse> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceCountAncestorsResponse", [
            { no: 1, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceCountAncestorsResponse
 */
export const AppEntitlementSearchServiceCountAncestorsResponse = new AppEntitlementSearchServiceCountAncestorsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceSearchAncestorsRequest$Type extends MessageType<AppEntitlementSearchServiceSearchAncestorsRequest> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceSearchAncestorsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "depth", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "validate.rules": { uint32: { lte: 2, gte: 1, ignoreEmpty: true } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask },
            { no: 5, name: "leaves_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "system_created_proxy_bindings_only", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 2000, gte: 0 } } } },
            { no: 8, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 9, name: "only_ancestors_without_descendants", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchAncestorsRequest
 */
export const AppEntitlementSearchServiceSearchAncestorsRequest = new AppEntitlementSearchServiceSearchAncestorsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AncestralBinding$Type extends MessageType<AncestralBinding> {
    constructor() {
        super("c1.api.app.v1.AncestralBinding", [
            { no: 1, name: "ancestor_entitlement", kind: "message", T: () => AppEntitlementView },
            { no: 2, name: "descendant_entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementView }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AncestralBinding
 */
export const AncestralBinding = new AncestralBinding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AncestralBindingRef$Type extends MessageType<AncestralBindingRef> {
    constructor() {
        super("c1.api.app.v1.AncestralBindingRef", [
            { no: 1, name: "ancestor_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "ancestor_app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AncestralBindingRef
 */
export const AncestralBindingRef = new AncestralBindingRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceSearchAncestorsResponse$Type extends MessageType<AppEntitlementSearchServiceSearchAncestorsResponse> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceSearchAncestorsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AncestralBinding },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchAncestorsResponse
 */
export const AppEntitlementSearchServiceSearchAncestorsResponse = new AppEntitlementSearchServiceSearchAncestorsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceSearchCountRequest$Type extends MessageType<AppEntitlementSearchServiceSearchCountRequest> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceSearchCountRequest", [
            { no: 1, name: "filter", kind: "message", T: () => AppEntitlementSearchServiceSearchRequest }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchCountRequest
 */
export const AppEntitlementSearchServiceSearchCountRequest = new AppEntitlementSearchServiceSearchCountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceSearchCountResponse$Type extends MessageType<AppEntitlementSearchServiceSearchCountResponse> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceSearchCountResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchCountResponse
 */
export const AppEntitlementSearchServiceSearchCountResponse = new AppEntitlementSearchServiceSearchCountResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceSearchExpiringAccessForUserRequest$Type extends MessageType<AppEntitlementSearchServiceSearchExpiringAccessForUserRequest> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceSearchExpiringAccessForUserRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask },
            { no: 5, name: "expires_before", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchExpiringAccessForUserRequest
 */
export const AppEntitlementSearchServiceSearchExpiringAccessForUserRequest = new AppEntitlementSearchServiceSearchExpiringAccessForUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementWithUserBinding$Type extends MessageType<AppEntitlementWithUserBinding> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementWithUserBinding", [
            { no: 1, name: "entitlement", kind: "message", T: () => AppEntitlementView },
            { no: 2, name: "app_entitlement_user_binding", kind: "message", T: () => AppEntitlementUserView }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementWithUserBinding
 */
export const AppEntitlementWithUserBinding = new AppEntitlementWithUserBinding$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceSearchExpiringAccessForUserResponse$Type extends MessageType<AppEntitlementSearchServiceSearchExpiringAccessForUserResponse> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceSearchExpiringAccessForUserResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementWithUserBinding },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchExpiringAccessForUserResponse
 */
export const AppEntitlementSearchServiceSearchExpiringAccessForUserResponse = new AppEntitlementSearchServiceSearchExpiringAccessForUserResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceSearchGrantsRequest$Type extends MessageType<AppEntitlementSearchServiceSearchGrantsRequest> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceSearchGrantsRequest", [
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask },
            { no: 5, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "app_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 7, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } },
            { no: 8, name: "resource_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } },
            { no: 9, name: "entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 10, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "purpose", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.app.v1.AppEntitlementPurposeValue", AppEntitlementPurposeValue, "APP_ENTITLEMENT_PURPOSE_VALUE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchGrantsRequest
 */
export const AppEntitlementSearchServiceSearchGrantsRequest = new AppEntitlementSearchServiceSearchGrantsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceSearchGrantsResponse$Type extends MessageType<AppEntitlementSearchServiceSearchGrantsResponse> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceSearchGrantsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementWithUserBinding },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchGrantsResponse
 */
export const AppEntitlementSearchServiceSearchGrantsResponse = new AppEntitlementSearchServiceSearchGrantsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceSearchExpiringAccessForUserCountRequest$Type extends MessageType<AppEntitlementSearchServiceSearchExpiringAccessForUserCountRequest> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceSearchExpiringAccessForUserCountRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "expires_before", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchExpiringAccessForUserCountRequest
 */
export const AppEntitlementSearchServiceSearchExpiringAccessForUserCountRequest = new AppEntitlementSearchServiceSearchExpiringAccessForUserCountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceSearchExpiringAccessForUserCountResponse$Type extends MessageType<AppEntitlementSearchServiceSearchExpiringAccessForUserCountResponse> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceSearchExpiringAccessForUserCountResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchExpiringAccessForUserCountResponse
 */
export const AppEntitlementSearchServiceSearchExpiringAccessForUserCountResponse = new AppEntitlementSearchServiceSearchExpiringAccessForUserCountResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountGrantsExpiringBeforeRequest$Type extends MessageType<CountGrantsExpiringBeforeRequest> {
    constructor() {
        super("c1.api.app.v1.CountGrantsExpiringBeforeRequest", [
            { no: 1, name: "expires_before", kind: "message", T: () => Timestamp, options: { "validate.rules": { timestamp: { required: true } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CountGrantsExpiringBeforeRequest
 */
export const CountGrantsExpiringBeforeRequest = new CountGrantsExpiringBeforeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountGrantsExpiringBeforeResponse$Type extends MessageType<CountGrantsExpiringBeforeResponse> {
    constructor() {
        super("c1.api.app.v1.CountGrantsExpiringBeforeResponse", [
            { no: 1, name: "count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CountGrantsExpiringBeforeResponse
 */
export const CountGrantsExpiringBeforeResponse = new CountGrantsExpiringBeforeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchGrantsExpiringBeforeRequest$Type extends MessageType<SearchGrantsExpiringBeforeRequest> {
    constructor() {
        super("c1.api.app.v1.SearchGrantsExpiringBeforeRequest", [
            { no: 1, name: "expires_before", kind: "message", T: () => Timestamp, options: { "validate.rules": { timestamp: { required: true } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchGrantsExpiringBeforeRequest
 */
export const SearchGrantsExpiringBeforeRequest = new SearchGrantsExpiringBeforeRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchGrantsExpiringBeforeResponse$Type extends MessageType<SearchGrantsExpiringBeforeResponse> {
    constructor() {
        super("c1.api.app.v1.SearchGrantsExpiringBeforeResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementWithUserBinding },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchGrantsExpiringBeforeResponse
 */
export const SearchGrantsExpiringBeforeResponse = new SearchGrantsExpiringBeforeResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceSearchTermsRequest$Type extends MessageType<AppEntitlementSearchServiceSearchTermsRequest> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceSearchTermsRequest", [
            { no: 1, name: "search", kind: "message", T: () => AppEntitlementSearchServiceSearchRequest },
            { no: 2, name: "term", kind: "enum", T: () => ["c1.api.app.v1.AppEntitlementSearchServiceSearchTermsRequest.TermType", AppEntitlementSearchServiceSearchTermsRequest_TermType] },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "include_count", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchTermsRequest
 */
export const AppEntitlementSearchServiceSearchTermsRequest = new AppEntitlementSearchServiceSearchTermsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceSearchTermsResponse$Type extends MessageType<AppEntitlementSearchServiceSearchTermsResponse> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceSearchTermsResponse", [
            { no: 1, name: "facets", kind: "message", T: () => Facets },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchTermsResponse
 */
export const AppEntitlementSearchServiceSearchTermsResponse = new AppEntitlementSearchServiceSearchTermsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceSearchRequest$Type extends MessageType<AppEntitlementSearchServiceSearchRequest> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceSearchRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "exclude_app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask },
            { no: 7, name: "exclude_app_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 8, name: "app_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 10, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } },
            { no: 11, name: "risk_level_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 12, name: "compliance_framework_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 19, name: "resource_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } },
            { no: 15, name: "only_get_expiring", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "access_review_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}|$" } } } },
            { no: 17, name: "alias", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "include_deleted", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 20, name: "is_automated", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 21, name: "resource_trait_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } },
            { no: 22, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef },
            { no: 24, name: "membership_type", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.app.v1.AppEntitlementMembershipType", AppEntitlementMembershipType, "APP_ENTITLEMENT_MEMBERSHIP_TYPE_"] },
            { no: 25, name: "exclude_resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } },
            { no: 26, name: "source_connector_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 27, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 28, name: "exclude_immutable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 29, name: "excluded_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 30, name: "policy_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PolicyRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchRequest
 */
export const AppEntitlementSearchServiceSearchRequest = new AppEntitlementSearchServiceSearchRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchServiceSearchResponse$Type extends MessageType<AppEntitlementSearchServiceSearchResponse> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchServiceSearchResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "facets", kind: "message", T: () => Facets }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchServiceSearchResponse
 */
export const AppEntitlementSearchServiceSearchResponse = new AppEntitlementSearchServiceSearchResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementsWithOneOwnerRequest$Type extends MessageType<SearchAppEntitlementsWithOneOwnerRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementsWithOneOwnerRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementsWithOneOwnerRequest
 */
export const SearchAppEntitlementsWithOneOwnerRequest = new SearchAppEntitlementsWithOneOwnerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementWithOneOwner$Type extends MessageType<AppEntitlementWithOneOwner> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementWithOneOwner", [
            { no: 1, name: "entitlement", kind: "message", T: () => AppEntitlementView },
            { no: 2, name: "user", kind: "message", T: () => User }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementWithOneOwner
 */
export const AppEntitlementWithOneOwner = new AppEntitlementWithOneOwner$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementsWithOneOwnerResponse$Type extends MessageType<SearchAppEntitlementsWithOneOwnerResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementsWithOneOwnerResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementWithOneOwner },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementsWithOneOwnerResponse
 */
export const SearchAppEntitlementsWithOneOwnerResponse = new SearchAppEntitlementsWithOneOwnerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementsWithDeactivatedOwnerRequest$Type extends MessageType<SearchAppEntitlementsWithDeactivatedOwnerRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementsWithDeactivatedOwnerRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementsWithDeactivatedOwnerRequest
 */
export const SearchAppEntitlementsWithDeactivatedOwnerRequest = new SearchAppEntitlementsWithDeactivatedOwnerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementWithDeactivatedOwner$Type extends MessageType<AppEntitlementWithDeactivatedOwner> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementWithDeactivatedOwner", [
            { no: 1, name: "entitlement", kind: "message", T: () => AppEntitlementView },
            { no: 3, name: "entitlement_owners", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementWithDeactivatedOwner
 */
export const AppEntitlementWithDeactivatedOwner = new AppEntitlementWithDeactivatedOwner$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementsWithDeactivatedOwnerResponse$Type extends MessageType<SearchAppEntitlementsWithDeactivatedOwnerResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementsWithDeactivatedOwnerResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementWithDeactivatedOwner },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementsWithDeactivatedOwnerResponse
 */
export const SearchAppEntitlementsWithDeactivatedOwnerResponse = new SearchAppEntitlementsWithDeactivatedOwnerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementsForAppUserRequest$Type extends MessageType<SearchAppEntitlementsForAppUserRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementsForAppUserRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask },
            { no: 4, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 6, name: "resource_type_trait_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementsForAppUserRequest
 */
export const SearchAppEntitlementsForAppUserRequest = new SearchAppEntitlementsForAppUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementsWithRevokableForAppUserRequest$Type extends MessageType<SearchAppEntitlementsWithRevokableForAppUserRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementsWithRevokableForAppUserRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 5, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementsWithRevokableForAppUserRequest
 */
export const SearchAppEntitlementsWithRevokableForAppUserRequest = new SearchAppEntitlementsWithRevokableForAppUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementsWithRevokableForAppUserResponse$Type extends MessageType<SearchAppEntitlementsWithRevokableForAppUserResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementsWithRevokableForAppUserResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementWithRevokable },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementsWithRevokableForAppUserResponse
 */
export const SearchAppEntitlementsWithRevokableForAppUserResponse = new SearchAppEntitlementsWithRevokableForAppUserResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementWithRevokable$Type extends MessageType<AppEntitlementWithRevokable> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementWithRevokable", [
            { no: 1, name: "app_entitlement", kind: "message", T: () => AppEntitlementView },
            { no: 2, name: "is_revokable", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementWithRevokable
 */
export const AppEntitlementWithRevokable = new AppEntitlementWithRevokable$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRequestableEntitlementsForUserRequest$Type extends MessageType<SearchRequestableEntitlementsForUserRequest> {
    constructor() {
        super("c1.api.app.v1.SearchRequestableEntitlementsForUserRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 8, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 10, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask },
            { no: 11, name: "sort_by", kind: "enum", T: () => ["c1.api.app.v1.SearchRequestableEntitlementsForUserSortBy", SearchRequestableEntitlementsForUserSortBy] },
            { no: 12, name: "exclude_resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 14, name: "include_resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchRequestableEntitlementsForUserRequest
 */
export const SearchRequestableEntitlementsForUserRequest = new SearchRequestableEntitlementsForUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchRequestableEntitlementsForUserResponse$Type extends MessageType<SearchRequestableEntitlementsForUserResponse> {
    constructor() {
        super("c1.api.app.v1.SearchRequestableEntitlementsForUserResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchRequestableEntitlementsForUserResponse
 */
export const SearchRequestableEntitlementsForUserResponse = new SearchRequestableEntitlementsForUserResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RollupEntitlementsWithGrantsRequest$Type extends MessageType<RollupEntitlementsWithGrantsRequest> {
    constructor() {
        super("c1.api.app.v1.RollupEntitlementsWithGrantsRequest", [
            { no: 1, name: "entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef },
            { no: 2, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementUserBindingRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 6, name: "user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.RollupEntitlementsWithGrantsRequest
 */
export const RollupEntitlementsWithGrantsRequest = new RollupEntitlementsWithGrantsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RollupEntitlementsWithGrantsResponse$Type extends MessageType<RollupEntitlementsWithGrantsResponse> {
    constructor() {
        super("c1.api.app.v1.RollupEntitlementsWithGrantsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementUserBinding },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.RollupEntitlementsWithGrantsResponse
 */
export const RollupEntitlementsWithGrantsResponse = new RollupEntitlementsWithGrantsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlement$Type extends MessageType<AppEntitlement> {
    constructor() {
        super("c1.api.app.v1.AppEntitlement", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "512" } } } },
            { no: 7, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } },
            { no: 10, name: "duration_unset", kind: "message", oneof: "maxGrantDuration", T: () => Empty },
            { no: 11, name: "duration_grant", kind: "message", oneof: "maxGrantDuration", T: () => Duration },
            { no: 13, name: "risk_level_value_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "compliance_framework_value_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "grant_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 18, name: "revoke_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 19, name: "certify_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 27, name: "emergency_grant_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 28, name: "emergency_grant_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 20, name: "grant_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 21, name: "provisioner_policy", kind: "message", T: () => ProvisionPolicy },
            { no: 22, name: "app_resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "app_resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "system_builtin", kind: "scalar", T: 8 /*ScalarType.BOOL*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 25, name: "slug", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 26, name: "alias", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-z0-9][-a-z0-9_.]{0,61}[a-z0-9]$", ignoreEmpty: true } } } },
            { no: 29, name: "user_edited_mask", kind: "message", T: () => FieldMask },
            { no: 30, name: "is_manually_managed", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 31, name: "source_connector_ids", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } },
            { no: 32, name: "override_access_requests_defaults", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 33, name: "default_values_applied", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 39, name: "is_automation_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 40, name: "purpose", kind: "enum", T: () => ["c1.api.app.v1.AppEntitlementPurposeValue", AppEntitlementPurposeValue, "APP_ENTITLEMENT_PURPOSE_VALUE_"] },
            { no: 41, name: "deprovisioner_policy", kind: "message", T: () => ProvisionPolicy },
            { no: 42, name: "match_baton_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 43, name: "request_schema_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "Custom App Entitlement" } }] }, "policy.v1.msg": { enabled: true, name: "app_entitlement", keyFields: ["id", "app_resource_id", "app_resource_type_id", "app_id"] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlement
 */
export const AppEntitlement = new AppEntitlement$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementView$Type extends MessageType<AppEntitlementView> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementView", [
            { no: 1, name: "app_entitlement", kind: "message", T: () => AppEntitlement },
            { no: 2, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_resource_type_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_resource_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "object_permissions", kind: "message", T: () => ActorObjectPermissions }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementView
 */
export const AppEntitlementView = new AppEntitlementView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CatalogEntry$Type extends MessageType<CatalogEntry> {
    constructor() {
        super("c1.api.app.v1.CatalogEntry", [
            { no: 1, name: "app_entitlement", kind: "message", T: () => AppEntitlement },
            { no: 2, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_resource_type_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_resource_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "enrolled_members_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 6, name: "total_members_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CatalogEntry
 */
export const CatalogEntry = new CatalogEntry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementExpandMask$Type extends MessageType<AppEntitlementExpandMask> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_id", "app_resource_type_id", "app_resource_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementExpandMask
 */
export const AppEntitlementExpandMask = new AppEntitlementExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAppEntitlementRequest$Type extends MessageType<CreateAppEntitlementRequest> {
    constructor() {
        super("c1.api.app.v1.CreateAppEntitlementRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "512" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask },
            { no: 5, name: "app_resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 6, name: "app_resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 7, name: "slug", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "512" } } } },
            { no: 8, name: "app_entitlement_owner_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 9, name: "emergency_grant_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 10, name: "emergency_grant_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 11, name: "grant_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 12, name: "revoke_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 13, name: "certify_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 14, name: "risk_level_value_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$", ignoreEmpty: true } } } },
            { no: 15, name: "compliance_framework_value_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 16, name: "alias", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-z0-9][-a-z0-9_.]{0,61}[a-z0-9]$", ignoreEmpty: true } } } },
            { no: 17, name: "purpose", kind: "enum", T: () => ["c1.api.app.v1.AppEntitlementPurposeValue", AppEntitlementPurposeValue, "APP_ENTITLEMENT_PURPOSE_VALUE_"] },
            { no: 18, name: "provision_policy", kind: "message", T: () => ProvisionPolicy },
            { no: 19, name: "duration_unset", kind: "message", oneof: "maxGrantDuration", T: () => Empty },
            { no: 20, name: "duration_grant", kind: "message", oneof: "maxGrantDuration", T: () => Duration },
            { no: 21, name: "override_access_requests_defaults", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 22, name: "match_baton_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CreateAppEntitlementRequest
 */
export const CreateAppEntitlementRequest = new CreateAppEntitlementRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateAppEntitlementResponse$Type extends MessageType<CreateAppEntitlementResponse> {
    constructor() {
        super("c1.api.app.v1.CreateAppEntitlementResponse", [
            { no: 1, name: "app_entitlement_view", kind: "message", T: () => AppEntitlementView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CreateAppEntitlementResponse
 */
export const CreateAppEntitlementResponse = new CreateAppEntitlementResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAppEntitlementRequest$Type extends MessageType<UpdateAppEntitlementRequest> {
    constructor() {
        super("c1.api.app.v1.UpdateAppEntitlementRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "entitlement", kind: "message", T: () => AppEntitlement, options: { "validate.rules": { message: { skip: true } } } },
            { no: 3, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask },
            { no: 5, name: "override_access_requests_defaults", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UpdateAppEntitlementRequest
 */
export const UpdateAppEntitlementRequest = new UpdateAppEntitlementRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateProvisionerPolicyAppEntitlementRequest$Type extends MessageType<UpdateProvisionerPolicyAppEntitlementRequest> {
    constructor() {
        super("c1.api.app.v1.UpdateProvisionerPolicyAppEntitlementRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "entitlement", kind: "message", T: () => AppEntitlement, options: { "validate.rules": { message: { skip: true } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UpdateProvisionerPolicyAppEntitlementRequest
 */
export const UpdateProvisionerPolicyAppEntitlementRequest = new UpdateProvisionerPolicyAppEntitlementRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateDeprovisionerPolicyAppEntitlementRequest$Type extends MessageType<UpdateDeprovisionerPolicyAppEntitlementRequest> {
    constructor() {
        super("c1.api.app.v1.UpdateDeprovisionerPolicyAppEntitlementRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "entitlement", kind: "message", T: () => AppEntitlement, options: { "validate.rules": { message: { skip: true } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UpdateDeprovisionerPolicyAppEntitlementRequest
 */
export const UpdateDeprovisionerPolicyAppEntitlementRequest = new UpdateDeprovisionerPolicyAppEntitlementRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UpdateAppEntitlementResponse$Type extends MessageType<UpdateAppEntitlementResponse> {
    constructor() {
        super("c1.api.app.v1.UpdateAppEntitlementResponse", [
            { no: 1, name: "app_entitlement_view", kind: "message", T: () => AppEntitlementView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UpdateAppEntitlementResponse
 */
export const UpdateAppEntitlementResponse = new UpdateAppEntitlementResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppEntitlementRequest$Type extends MessageType<GetAppEntitlementRequest> {
    constructor() {
        super("c1.api.app.v1.GetAppEntitlementRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAppEntitlementRequest
 */
export const GetAppEntitlementRequest = new GetAppEntitlementRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppEntitlementResponse$Type extends MessageType<GetAppEntitlementResponse> {
    constructor() {
        super("c1.api.app.v1.GetAppEntitlementResponse", [
            { no: 1, name: "app_entitlement_view", kind: "message", T: () => AppEntitlementView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAppEntitlementResponse
 */
export const GetAppEntitlementResponse = new GetAppEntitlementResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkGetAppEntitlementsRequest$Type extends MessageType<BulkGetAppEntitlementsRequest> {
    constructor() {
        super("c1.api.app.v1.BulkGetAppEntitlementsRequest", [
            { no: 1, name: "app_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "100" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.BulkGetAppEntitlementsRequest
 */
export const BulkGetAppEntitlementsRequest = new BulkGetAppEntitlementsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkGetAppEntitlementsResponse$Type extends MessageType<BulkGetAppEntitlementsResponse> {
    constructor() {
        super("c1.api.app.v1.BulkGetAppEntitlementsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlement }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.BulkGetAppEntitlementsResponse
 */
export const BulkGetAppEntitlementsResponse = new BulkGetAppEntitlementsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppEntitlementRequest$Type extends MessageType<DeleteAppEntitlementRequest> {
    constructor() {
        super("c1.api.app.v1.DeleteAppEntitlementRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAppEntitlementRequest
 */
export const DeleteAppEntitlementRequest = new DeleteAppEntitlementRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppEntitlementResponse$Type extends MessageType<DeleteAppEntitlementResponse> {
    constructor() {
        super("c1.api.app.v1.DeleteAppEntitlementResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAppEntitlementResponse
 */
export const DeleteAppEntitlementResponse = new DeleteAppEntitlementResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteAppEntitlementIfManuallyCreatedRequest$Type extends MessageType<DeleteAppEntitlementIfManuallyCreatedRequest> {
    constructor() {
        super("c1.api.app.v1.DeleteAppEntitlementIfManuallyCreatedRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteAppEntitlementIfManuallyCreatedRequest
 */
export const DeleteAppEntitlementIfManuallyCreatedRequest = new DeleteAppEntitlementIfManuallyCreatedRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementsRequest$Type extends MessageType<ListAppEntitlementsRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppEntitlementsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppEntitlementsRequest
 */
export const ListAppEntitlementsRequest = new ListAppEntitlementsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementsResponse$Type extends MessageType<ListAppEntitlementsResponse> {
    constructor() {
        super("c1.api.app.v1.ListAppEntitlementsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppEntitlementsResponse
 */
export const ListAppEntitlementsResponse = new ListAppEntitlementsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementUserView$Type extends MessageType<AppEntitlementUserView> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementUserView", [
            { no: 1, name: "app_user", kind: "message", T: () => AppUserView },
            { no: 2, name: "app_entitlement_user_binding_created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "app_entitlement_user_binding_deprovision_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "grant_sources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementUserView
 */
export const AppEntitlementUserView = new AppEntitlementUserView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementUsersRequest$Type extends MessageType<ListAppEntitlementUsersRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppEntitlementUsersRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppUserExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppEntitlementUsersRequest
 */
export const ListAppEntitlementUsersRequest = new ListAppEntitlementUsersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementUsersResponse$Type extends MessageType<ListAppEntitlementUsersResponse> {
    constructor() {
        super("c1.api.app.v1.ListAppEntitlementUsersResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementUserView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppEntitlementUsersResponse
 */
export const ListAppEntitlementUsersResponse = new ListAppEntitlementUsersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementsWithExpiredRequest$Type extends MessageType<SearchAppEntitlementsWithExpiredRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementsWithExpiredRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementUserBindingRef },
            { no: 7, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 8, name: "app_user_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 9, name: "user_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "100" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementsWithExpiredRequest
 */
export const SearchAppEntitlementsWithExpiredRequest = new SearchAppEntitlementsWithExpiredRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementWithExpired$Type extends MessageType<AppEntitlementWithExpired> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementWithExpired", [
            { no: 1, name: "app_user", kind: "message", T: () => AppUser },
            { no: 2, name: "user", kind: "message", T: () => User },
            { no: 3, name: "expired", kind: "message", T: () => Timestamp },
            { no: 4, name: "discovered", kind: "message", T: () => Timestamp },
            { no: 5, name: "grant_reasons", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => GrantReason },
            { no: 6, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "grant_sources", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementWithExpired
 */
export const AppEntitlementWithExpired = new AppEntitlementWithExpired$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppEntitlementsWithExpiredResponse$Type extends MessageType<SearchAppEntitlementsWithExpiredResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppEntitlementsWithExpiredResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementWithExpired },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppEntitlementsWithExpiredResponse
 */
export const SearchAppEntitlementsWithExpiredResponse = new SearchAppEntitlementsWithExpiredResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementsForAppUserRequest$Type extends MessageType<ListAppEntitlementsForAppUserRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppEntitlementsForAppUserRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppEntitlementsForAppUserRequest
 */
export const ListAppEntitlementsForAppUserRequest = new ListAppEntitlementsForAppUserRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementGroupsRequest$Type extends MessageType<ListAppEntitlementGroupsRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppEntitlementGroupsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppEntitlementGroupsRequest
 */
export const ListAppEntitlementGroupsRequest = new ListAppEntitlementGroupsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementGroupsResponse$Type extends MessageType<ListAppEntitlementGroupsResponse> {
    constructor() {
        super("c1.api.app.v1.ListAppEntitlementGroupsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppGroup },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "notification_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppEntitlementGroupsResponse
 */
export const ListAppEntitlementGroupsResponse = new ListAppEntitlementGroupsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAppEntitlementsForAppResourceRequest$Type extends MessageType<ListAppEntitlementsForAppResourceRequest> {
    constructor() {
        super("c1.api.app.v1.ListAppEntitlementsForAppResourceRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 5, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "expand_mask", kind: "message", T: () => AppEntitlementExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAppEntitlementsForAppResourceRequest
 */
export const ListAppEntitlementsForAppResourceRequest = new ListAppEntitlementsForAppResourceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppWithGrantCount$Type extends MessageType<AppWithGrantCount> {
    constructor() {
        super("c1.api.app.v1.AppWithGrantCount", [
            { no: 1, name: "App", kind: "message", jsonName: "App", T: () => App },
            { no: 2, name: "Count", kind: "scalar", jsonName: "Count", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppWithGrantCount
 */
export const AppWithGrantCount = new AppWithGrantCount$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountStandingHighRiskGrantsRequest$Type extends MessageType<CountStandingHighRiskGrantsRequest> {
    constructor() {
        super("c1.api.app.v1.CountStandingHighRiskGrantsRequest", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CountStandingHighRiskGrantsRequest
 */
export const CountStandingHighRiskGrantsRequest = new CountStandingHighRiskGrantsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CountStandingHighRiskGrantsResponse$Type extends MessageType<CountStandingHighRiskGrantsResponse> {
    constructor() {
        super("c1.api.app.v1.CountStandingHighRiskGrantsResponse", [
            { no: 1, name: "total_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CountStandingHighRiskGrantsResponse
 */
export const CountStandingHighRiskGrantsResponse = new CountStandingHighRiskGrantsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchStandingHighRiskGrantsForAppsRequest$Type extends MessageType<SearchStandingHighRiskGrantsForAppsRequest> {
    constructor() {
        super("c1.api.app.v1.SearchStandingHighRiskGrantsForAppsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchStandingHighRiskGrantsForAppsRequest
 */
export const SearchStandingHighRiskGrantsForAppsRequest = new SearchStandingHighRiskGrantsForAppsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchStandingHighRiskGrantsForAppsResponse$Type extends MessageType<SearchStandingHighRiskGrantsForAppsResponse> {
    constructor() {
        super("c1.api.app.v1.SearchStandingHighRiskGrantsForAppsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppWithGrantCount },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchStandingHighRiskGrantsForAppsResponse
 */
export const SearchStandingHighRiskGrantsForAppsResponse = new SearchStandingHighRiskGrantsForAppsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementAutomationRef$Type extends MessageType<AppEntitlementAutomationRef> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementAutomationRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementAutomationRef
 */
export const AppEntitlementAutomationRef = new AppEntitlementAutomationRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementServiceGetAutomationRequest$Type extends MessageType<AppEntitlementServiceGetAutomationRequest> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementServiceGetAutomationRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementServiceGetAutomationRequest
 */
export const AppEntitlementServiceGetAutomationRequest = new AppEntitlementServiceGetAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementServiceGetAutomationResponse$Type extends MessageType<AppEntitlementServiceGetAutomationResponse> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementServiceGetAutomationResponse", [
            { no: 1, name: "AppEntitlementAutomation", kind: "message", jsonName: "AppEntitlementAutomation", T: () => AppEntitlementAutomation }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementServiceGetAutomationResponse
 */
export const AppEntitlementServiceGetAutomationResponse = new AppEntitlementServiceGetAutomationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementServicePreviewAutomationCELRequest$Type extends MessageType<AppEntitlementServicePreviewAutomationCELRequest> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementServicePreviewAutomationCELRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "expression", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementServicePreviewAutomationCELRequest
 */
export const AppEntitlementServicePreviewAutomationCELRequest = new AppEntitlementServicePreviewAutomationCELRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementServicePreviewAutomationCELResponse$Type extends MessageType<AppEntitlementServicePreviewAutomationCELResponse> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse", [
            { no: 1, name: "matched", kind: "message", oneof: "response", T: () => AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseMatched },
            { no: 2, name: "status", kind: "message", oneof: "response", T: () => AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseStatus },
            { no: 3, name: "failed", kind: "message", oneof: "response", T: () => AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseFailed },
            { no: 4, name: "stopped", kind: "scalar", oneof: "response", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse
 */
export const AppEntitlementServicePreviewAutomationCELResponse = new AppEntitlementServicePreviewAutomationCELResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseMatched$Type extends MessageType<AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseMatched> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse.PreviewAutomationCELResponseMatched", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse.PreviewAutomationCELResponseMatched
 */
export const AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseMatched = new AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseMatched$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseFailed$Type extends MessageType<AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseFailed> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse.PreviewAutomationCELResponseFailed", [
            { no: 1, name: "user", kind: "message", T: () => User },
            { no: 2, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse.PreviewAutomationCELResponseFailed
 */
export const AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseFailed = new AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseFailed$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseStatus$Type extends MessageType<AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseStatus> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse.PreviewAutomationCELResponseStatus", [
            { no: 1, name: "total", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 2, name: "scanned", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "matched", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "errors", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementServicePreviewAutomationCELResponse.PreviewAutomationCELResponseStatus
 */
export const AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseStatus = new AppEntitlementServicePreviewAutomationCELResponse_PreviewAutomationCELResponseStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementServiceUpdateAutomationRequest$Type extends MessageType<AppEntitlementServiceUpdateAutomationRequest> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementServiceUpdateAutomationRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "512" } } } },
            { no: 4, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } },
            { no: 100, name: "none", kind: "message", oneof: "conditions", T: () => AppEntitlementAutomationRuleNone },
            { no: 101, name: "entitlements", kind: "message", oneof: "conditions", T: () => AppEntitlementAutomationRuleEntitlement },
            { no: 102, name: "cel", kind: "message", oneof: "conditions", T: () => AppEntitlementAutomationRuleCEL },
            { no: 103, name: "basic", kind: "message", oneof: "conditions", T: () => AppEntitlementAutomationRuleBasic },
            { no: 5, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementServiceUpdateAutomationRequest
 */
export const AppEntitlementServiceUpdateAutomationRequest = new AppEntitlementServiceUpdateAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementServiceUpdateAutomationResponse$Type extends MessageType<AppEntitlementServiceUpdateAutomationResponse> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementServiceUpdateAutomationResponse", [
            { no: 1, name: "AppEntitlementAutomation", kind: "message", jsonName: "AppEntitlementAutomation", T: () => AppEntitlementAutomation }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementServiceUpdateAutomationResponse
 */
export const AppEntitlementServiceUpdateAutomationResponse = new AppEntitlementServiceUpdateAutomationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementAutomationRuleNone$Type extends MessageType<AppEntitlementAutomationRuleNone> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementAutomationRuleNone", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementAutomationRuleNone
 */
export const AppEntitlementAutomationRuleNone = new AppEntitlementAutomationRuleNone$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementAutomationRuleEntitlement$Type extends MessageType<AppEntitlementAutomationRuleEntitlement> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementAutomationRuleEntitlement", [
            { no: 1, name: "entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "32" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementAutomationRuleEntitlement
 */
export const AppEntitlementAutomationRuleEntitlement = new AppEntitlementAutomationRuleEntitlement$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementAutomationRuleCEL$Type extends MessageType<AppEntitlementAutomationRuleCEL> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementAutomationRuleCEL", [
            { no: 1, name: "expression", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementAutomationRuleCEL
 */
export const AppEntitlementAutomationRuleCEL = new AppEntitlementAutomationRuleCEL$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementAutomationRuleBasic$Type extends MessageType<AppEntitlementAutomationRuleBasic> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementAutomationRuleBasic", [
            { no: 1, name: "expression", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementAutomationRuleBasic
 */
export const AppEntitlementAutomationRuleBasic = new AppEntitlementAutomationRuleBasic$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementAutomationLastRunStatus$Type extends MessageType<AppEntitlementAutomationLastRunStatus> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementAutomationLastRunStatus", [
            { no: 1, name: "last_completed_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "status", kind: "enum", T: () => ["c1.api.app.v1.AppEntitlementAutomationRunStatus", AppEntitlementAutomationRunStatus, "APP_ENTITLEMENT_AUTOMATION_RUN_STATUS_"], options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementAutomationLastRunStatus
 */
export const AppEntitlementAutomationLastRunStatus = new AppEntitlementAutomationLastRunStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementAutomation$Type extends MessageType<AppEntitlementAutomation> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementAutomation", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "512" } } } },
            { no: 7, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } },
            { no: 100, name: "none", kind: "message", oneof: "conditions", T: () => AppEntitlementAutomationRuleNone },
            { no: 101, name: "entitlements", kind: "message", oneof: "conditions", T: () => AppEntitlementAutomationRuleEntitlement },
            { no: 102, name: "cel", kind: "message", oneof: "conditions", T: () => AppEntitlementAutomationRuleCEL },
            { no: 103, name: "basic", kind: "message", oneof: "conditions", T: () => AppEntitlementAutomationRuleBasic },
            { no: 8, name: "last_run_status", kind: "message", T: () => AppEntitlementAutomationLastRunStatus, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "App Entitlement Automation" } }] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementAutomation
 */
export const AppEntitlementAutomation = new AppEntitlementAutomation$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddAutomationExclusionRequest$Type extends MessageType<AddAutomationExclusionRequest> {
    constructor() {
        super("c1.api.app.v1.AddAutomationExclusionRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AddAutomationExclusionRequest
 */
export const AddAutomationExclusionRequest = new AddAutomationExclusionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddAutomationExclusionResponse$Type extends MessageType<AddAutomationExclusionResponse> {
    constructor() {
        super("c1.api.app.v1.AddAutomationExclusionResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AddAutomationExclusionResponse
 */
export const AddAutomationExclusionResponse = new AddAutomationExclusionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveAutomationExclusionRequest$Type extends MessageType<RemoveAutomationExclusionRequest> {
    constructor() {
        super("c1.api.app.v1.RemoveAutomationExclusionRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.RemoveAutomationExclusionRequest
 */
export const RemoveAutomationExclusionRequest = new RemoveAutomationExclusionRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveAutomationExclusionResponse$Type extends MessageType<RemoveAutomationExclusionResponse> {
    constructor() {
        super("c1.api.app.v1.RemoveAutomationExclusionResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.RemoveAutomationExclusionResponse
 */
export const RemoveAutomationExclusionResponse = new RemoveAutomationExclusionResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAutomationExclusionsRequest$Type extends MessageType<ListAutomationExclusionsRequest> {
    constructor() {
        super("c1.api.app.v1.ListAutomationExclusionsRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 4, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 6, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementUserBindingRef }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAutomationExclusionsRequest
 */
export const ListAutomationExclusionsRequest = new ListAutomationExclusionsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class UserWithAppEntitlementUserBindingView$Type extends MessageType<UserWithAppEntitlementUserBindingView> {
    constructor() {
        super("c1.api.app.v1.UserWithAppEntitlementUserBindingView", [
            { no: 1, name: "user", kind: "message", T: () => User },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.UserWithAppEntitlementUserBindingView
 */
export const UserWithAppEntitlementUserBindingView = new UserWithAppEntitlementUserBindingView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ListAutomationExclusionsResponse$Type extends MessageType<ListAutomationExclusionsResponse> {
    constructor() {
        super("c1.api.app.v1.ListAutomationExclusionsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => UserWithAppEntitlementUserBindingView },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ListAutomationExclusionsResponse
 */
export const ListAutomationExclusionsResponse = new ListAutomationExclusionsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AddManuallyManagedUsersRequest$Type extends MessageType<AddManuallyManagedUsersRequest> {
    constructor() {
        super("c1.api.app.v1.AddManuallyManagedUsersRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "10", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AddManuallyManagedUsersRequest
 */
export const AddManuallyManagedUsersRequest = new AddManuallyManagedUsersRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ManuallyManagedUsersResponse$Type extends MessageType<ManuallyManagedUsersResponse> {
    constructor() {
        super("c1.api.app.v1.ManuallyManagedUsersResponse", [
            { no: 1, name: "failed_users_error_map", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "scalar", T: 9 /*ScalarType.STRING*/ } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ManuallyManagedUsersResponse
 */
export const ManuallyManagedUsersResponse = new ManuallyManagedUsersResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveEntitlementMembershipRequest$Type extends MessageType<RemoveEntitlementMembershipRequest> {
    constructor() {
        super("c1.api.app.v1.RemoveEntitlementMembershipRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.RemoveEntitlementMembershipRequest
 */
export const RemoveEntitlementMembershipRequest = new RemoveEntitlementMembershipRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class RemoveEntitlementMembershipResponse$Type extends MessageType<RemoveEntitlementMembershipResponse> {
    constructor() {
        super("c1.api.app.v1.RemoveEntitlementMembershipResponse", [
            { no: 1, name: "revoke_task_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.RemoveEntitlementMembershipResponse
 */
export const RemoveEntitlementMembershipResponse = new RemoveEntitlementMembershipResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ForceRunDynamicGroupAutomationRequest$Type extends MessageType<ForceRunDynamicGroupAutomationRequest> {
    constructor() {
        super("c1.api.app.v1.ForceRunDynamicGroupAutomationRequest", [
            { no: 1, name: "app_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ForceRunDynamicGroupAutomationRequest
 */
export const ForceRunDynamicGroupAutomationRequest = new ForceRunDynamicGroupAutomationRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ForceRunDynamicGroupAutomationResponse$Type extends MessageType<ForceRunDynamicGroupAutomationResponse> {
    constructor() {
        super("c1.api.app.v1.ForceRunDynamicGroupAutomationResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.ForceRunDynamicGroupAutomationResponse
 */
export const ForceRunDynamicGroupAutomationResponse = new ForceRunDynamicGroupAutomationResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementSearchFilter$Type extends MessageType<AppEntitlementSearchFilter> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementSearchFilter", [
            { no: 12, name: "app_entitlement_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "500" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementSearchFilter
 */
export const AppEntitlementSearchFilter = new AppEntitlementSearchFilter$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppEntitlementUserBindingSearchFilter$Type extends MessageType<AppEntitlementUserBindingSearchFilter> {
    constructor() {
        super("c1.api.app.v1.AppEntitlementUserBindingSearchFilter", [
            { no: 1, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementUserBindingRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "500" } } } },
            { no: 2, name: "app_user_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppUserRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 3, name: "exclude_refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlementUserBindingRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "500" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppEntitlementUserBindingSearchFilter
 */
export const AppEntitlementUserBindingSearchFilter = new AppEntitlementUserBindingSearchFilter$Type();
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppEntitlements
 */
export const AppEntitlements = new ServiceType("c1.api.app.v1.AppEntitlements", [
    { name: "Create", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/entitlements", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "Custom App Entitlement" }], group: "App Entitlement" }] } }, I: CreateAppEntitlementRequest, O: CreateAppEntitlementResponse },
    { name: "Get", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/entitlements/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "Custom App Entitlement", optionalExclusion: "OPTIONAL_EXCLUSION_RESOURCE_ONLY" }], group: "App Entitlement" }] } }, I: GetAppEntitlementRequest, O: GetAppEntitlementResponse },
    { name: "BulkGet", options: { "authz.method": { role: "VIEWER" } }, I: BulkGetAppEntitlementsRequest, O: BulkGetAppEntitlementsResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/entitlements", query: { page_size: "page_size", page_token: "page_token" }, group: "App Entitlement" }] } }, I: ListAppEntitlementsRequest, O: ListAppEntitlementsResponse },
    { name: "ListUsers", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/entitlements/{app_entitlement_id}/users", query: { page_size: "page_size", page_token: "page_token" }, terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "AppEntitlementUsers", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "App Entitlement", pagination: { type: "TERRAFORM_ENTITY_PAGINATION_TYPE_CURSOR", inputs: [{ name: "pageToken", type: "TERRAFORM_ENTITY_PAGINATION_INPUT_TYPE_CURSOR" }], outputs: { nextCursor: "$.nextPageToken" } } }] } }, I: ListAppEntitlementUsersRequest, O: ListAppEntitlementUsersResponse },
    { name: "ListForAppUser", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/entitlements/users/{app_user_id}", query: { page_size: "page_size", page_token: "page_token" }, group: "App Entitlement" }] } }, I: ListAppEntitlementsForAppUserRequest, O: ListAppEntitlementsResponse },
    { name: "ListForAppResource", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/entitlements/resource_types/{app_resource_type_id}/resources/{app_resource_id}", query: { page_size: "page_size", page_token: "page_token" }, group: "App Entitlement" }] } }, I: ListAppEntitlementsForAppResourceRequest, O: ListAppEntitlementsResponse },
    { name: "UpdateProvisionerPolicy", options: { "authz.method": { role: "VIEWER" } }, I: UpdateProvisionerPolicyAppEntitlementRequest, O: UpdateAppEntitlementResponse },
    { name: "UpdateDeprovisionerPolicy", options: { "authz.method": { role: "VIEWER" } }, I: UpdateDeprovisionerPolicyAppEntitlementRequest, O: UpdateAppEntitlementResponse },
    { name: "Update", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/entitlements/{entitlement.id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "Custom App Entitlement" }], group: "App Entitlement" }] } }, I: UpdateAppEntitlementRequest, O: UpdateAppEntitlementResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/apps/{app_id}/entitlements/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "Custom App Entitlement" }], group: "App Entitlement" }] } }, I: DeleteAppEntitlementRequest, O: DeleteAppEntitlementResponse },
    { name: "DeleteIfManuallyCreated", options: { "authz.method": { role: "EDITOR" } }, I: DeleteAppEntitlementIfManuallyCreatedRequest, O: Empty },
    { name: "CreateAutomation", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/entitlements/{app_entitlement_id}/automation/create", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "App Entitlement Automation" }], group: "App Entitlement Automation" }] } }, I: CreateAutomationRequest, O: CreateAutomationResponse },
    { name: "DeleteAutomation", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/apps/{app_id}/entitlements/{app_entitlement_id}/automation", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "App Entitlement Automation" }], group: "App Entitlement Automation" }] } }, I: DeleteAutomationRequest, O: DeleteAutomationResponse },
    { name: "GetAutomation", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/entitlements/{app_entitlement_id}/automation", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "App Entitlement Automation" }], group: "App Entitlement Automation" }] } }, I: AppEntitlementServiceGetAutomationRequest, O: AppEntitlementServiceGetAutomationResponse },
    { name: "PreviewAutomationCEL", serverStreaming: true, options: { "authz.method": { role: "VIEWER" } }, I: AppEntitlementServicePreviewAutomationCELRequest, O: AppEntitlementServicePreviewAutomationCELResponse },
    { name: "UpdateAutomation", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/entitlements/{app_entitlement_id}/automation/update", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "App Entitlement Automation" }], group: "App Entitlement Automation" }] } }, I: AppEntitlementServiceUpdateAutomationRequest, O: AppEntitlementServiceUpdateAutomationResponse },
    { name: "AddAutomationExclusion", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/entitlements/{app_entitlement_id}/automation/exclusions", group: "App Entitlement Automation Exclusion" }] } }, I: AddAutomationExclusionRequest, O: AddAutomationExclusionResponse },
    { name: "RemoveAutomationExclusion", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/apps/{app_id}/entitlements/{app_entitlement_id}/automation/exclusions", group: "App Entitlement Automation Exclusion" }] } }, I: RemoveAutomationExclusionRequest, O: RemoveAutomationExclusionResponse },
    { name: "ListAutomationExclusions", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/entitlements/{app_entitlement_id}/automation/exclusions", group: "App Entitlement Automation Exclusion" }] } }, I: ListAutomationExclusionsRequest, O: ListAutomationExclusionsResponse },
    { name: "AddManuallyManagedMembers", options: { "authz.method": { role: "OWNER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/entitlements/{app_entitlement_id}/add-manual-user", group: "App Entitlement" }] } }, I: AddManuallyManagedUsersRequest, O: ManuallyManagedUsersResponse },
    { name: "RemoveEntitlementMembership", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/apps/{app_id}/entitlements/{app_entitlement_id}/remove-membership", group: "App Entitlement" }] } }, I: RemoveEntitlementMembershipRequest, O: RemoveEntitlementMembershipResponse },
    { name: "ForceRunDynamicGroupAutomation", options: { "authz.method": { role: "EDITOR" } }, I: ForceRunDynamicGroupAutomationRequest, O: ForceRunDynamicGroupAutomationResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppEntitlementSearchService
 */
export const AppEntitlementSearchService = new ServiceType("c1.api.app.v1.AppEntitlementSearchService", [
    { name: "Search", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/entitlements", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "App Entitlement", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }, { type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "App Entitlements", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "App Entitlement", pagination: { type: "TERRAFORM_ENTITY_PAGINATION_TYPE_CURSOR", inputs: [{ name: "pageToken", in: "TERRAFORM_ENTITY_PAGINATION_INPUT_IN_REQUEST_BODY", type: "TERRAFORM_ENTITY_PAGINATION_INPUT_TYPE_CURSOR" }], outputs: { nextCursor: "$.nextPageToken" } } }] } }, I: AppEntitlementSearchServiceSearchRequest, O: AppEntitlementSearchServiceSearchResponse },
    { name: "SearchAppEntitlementsWithExpired", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/entitlements/{app_entitlement_id}/grants", query: { page_size: "page_size", page_token: "page_token" }, group: "App Entitlement" }] } }, I: SearchAppEntitlementsWithExpiredRequest, O: SearchAppEntitlementsWithExpiredResponse },
    { name: "GetSearchTerms", options: { "authz.method": { role: "VIEWER" } }, I: AppEntitlementSearchServiceSearchTermsRequest, O: AppEntitlementSearchServiceSearchTermsResponse },
    { name: "SearchCount", options: { "authz.method": { role: "VIEWER" } }, I: AppEntitlementSearchServiceSearchCountRequest, O: AppEntitlementSearchServiceSearchCountResponse },
    { name: "SearchExpiringAccessForUser", options: { "authz.method": { role: "VIEWER" } }, I: AppEntitlementSearchServiceSearchExpiringAccessForUserRequest, O: AppEntitlementSearchServiceSearchExpiringAccessForUserResponse },
    { name: "SearchGrants", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/grants", group: "App Entitlement" }] } }, I: AppEntitlementSearchServiceSearchGrantsRequest, O: AppEntitlementSearchServiceSearchGrantsResponse },
    { name: "SearchExpiringAccessForUserCount", options: { "authz.method": { role: "VIEWER" } }, I: AppEntitlementSearchServiceSearchExpiringAccessForUserCountRequest, O: AppEntitlementSearchServiceSearchExpiringAccessForUserCountResponse },
    { name: "CountStandingHighRiskGrants", options: { "authz.method": { role: "EDITOR" } }, I: CountStandingHighRiskGrantsRequest, O: CountStandingHighRiskGrantsResponse },
    { name: "SearchStandingHighRiskGrantsForApps", options: { "authz.method": { role: "EDITOR" } }, I: SearchStandingHighRiskGrantsForAppsRequest, O: SearchStandingHighRiskGrantsForAppsResponse },
    { name: "SearchAncestors", options: { "authz.method": { role: "VIEWER" } }, I: AppEntitlementSearchServiceSearchAncestorsRequest, O: AppEntitlementSearchServiceSearchAncestorsResponse },
    { name: "CountAncestors", options: { "authz.method": { role: "VIEWER" } }, I: AppEntitlementSearchServiceCountAncestorsRequest, O: AppEntitlementSearchServiceCountAncestorsResponse },
    { name: "SearchAppEntitlementsWithOneOwner", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppEntitlementsWithOneOwnerRequest, O: SearchAppEntitlementsWithOneOwnerResponse },
    { name: "SearchAppEntitlementsWithDeactivatedOwner", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppEntitlementsWithDeactivatedOwnerRequest, O: SearchAppEntitlementsWithDeactivatedOwnerResponse },
    { name: "SearchAppEntitlementsWithRevokableForAppUser", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppEntitlementsWithRevokableForAppUserRequest, O: SearchAppEntitlementsWithRevokableForAppUserResponse },
    { name: "SearchAppEntitlementsForAppUser", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/search/apps/{app_id}/entitlements/users/{app_user_id}", query: { page_size: "page_size", page_token: "page_token" }, group: "App Entitlement" }] } }, I: SearchAppEntitlementsForAppUserRequest, O: ListAppEntitlementsResponse },
    { name: "SearchRequestableEntitlementsForUser", options: { "authz.method": { role: "VIEWER" } }, I: SearchRequestableEntitlementsForUserRequest, O: SearchRequestableEntitlementsForUserResponse },
    { name: "RollupEntitlementsWithGrants", options: { "authz.method": { role: "VIEWER" } }, I: RollupEntitlementsWithGrantsRequest, O: RollupEntitlementsWithGrantsResponse },
    { name: "SearchAppEntitlementUserBindingDestinations", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppEntitlementUserBindingDestinationsRequest, O: SearchAppEntitlementUserBindingDestinationsResponse },
    { name: "SearchAppEntitlementUserBindingSources", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppEntitlementUserBindingSourcesRequest, O: SearchAppEntitlementUserBindingSourcesResponse },
    { name: "SearchAppEntitlementCorrelationForAccessProfile", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppEntitlementCorrelationForAccessProfileRequest, O: SearchAppEntitlementCorrelationForAccessProfileResponse },
    { name: "CountGrantsExpiringBefore", options: { "authz.method": { role: "VIEWER" } }, I: CountGrantsExpiringBeforeRequest, O: CountGrantsExpiringBeforeResponse },
    { name: "SearchGrantsExpiringBefore", options: { "authz.method": { role: "VIEWER" } }, I: SearchGrantsExpiringBeforeRequest, O: SearchGrantsExpiringBeforeResponse }
]);
